/*
 * Copyright French Prime minister Office/SGMAP/DINSIC/Vitam Program (2019-2022)
 * and the signatories of the "VITAM - Accord du Contributeur" agreement.
 *
 * contact@programmevitam.fr
 *
 * This software is a computer program whose purpose is to implement
 * implement a digital archiving front-office system for the secure and
 * efficient high volumetry VITAM solution.
 *
 * This software is governed by the CeCILL-C license under French law and
 * abiding by the rules of distribution of free software.  You can  use,
 * modify and/ or redistribute the software under the terms of the CeCILL-C
 * license as circulated by CEA, CNRS and INRIA at the following URL
 * "http://www.cecill.info".
 *
 * As a counterpart to the access to the source code and  rights to copy,
 * modify and redistribute granted by the license, users are provided only
 * with a limited warranty  and the software's author,  the holder of the
 * economic rights,  and the successive licensors  have only  limited
 * liability.
 *
 * In this respect, the user's attention is drawn to the risks associated
 * with loading,  using,  modifying and/or developing or reproducing the
 * software by the user in light of its specific status of free software,
 * that may mean  that it is complicated to manipulate,  and  that  also
 * therefore means  that it is reserved for developers  and  experienced
 * professionals having in-depth computer knowledge. Users are therefore
 * encouraged to load and test the software's suitability as regards their
 * requirements in conditions enabling the security of their systems and/or
 * data to be ensured and,  more generally, to use and operate it in the
 * same conditions as regards security.
 *
 * The fact that you are presently reading this means that you have had
 * knowledge of the CeCILL-C license and that you accept its terms.
 */
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Collection } from '../models/schema/collection.enum';
import { ProfiledSchemaElement, SchemaElement } from '../models/schema/schema-element.model';
import { Schema } from '../models/schema/schema.interface';
import { Control } from '../models/schema/control.model';
import { EffectiveCardinality } from '../object-viewer/types';
import { map } from 'rxjs/operators';
import { ItemNode } from '../components/autocomplete/utils/item-node.interface';

@Injectable()
export class MockSchemaService {
  private schema: ProfiledSchemaElement[] = [
    {
      id: null,
      Path: 'AcquiredDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'AcquiredDate',
      ShortName: 'Date de numérisation',
      Description: 'Mapping : unit-es-mapping.json. Références : ARKMS.DateAcquired',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'AcquiredDate',
      ApiField: 'AcquiredDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'AcquiredDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: 'Addressee',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'Addressee',
      ShortName: 'Destinataire',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Addressee',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Addressee',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'Addressee.Activity',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Activity',
      ShortName: 'Activité',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Activité.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Activity',
      ApiField: 'Activity',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Addressee.Activity',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Addressee.BirthDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'BirthDate',
      ShortName: 'Date de naissance',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'BirthDate',
      ApiField: 'BirthDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Addressee.BirthDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: 'Addressee.BirthName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'BirthName',
      ShortName: 'Nom de naissance',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'BirthName',
      ApiField: 'BirthName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Addressee.BirthName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Addressee.BirthPlace',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'BirthPlace',
      ShortName: 'Lieu de naissance',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'BirthPlace',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Addressee.BirthPlace',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'Addressee.BirthPlace.Address',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Address',
      ShortName: 'Adresse',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Adresse. Références : ead.address",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Address',
      ApiField: 'Address',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Addressee.BirthPlace.Address',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Addressee.BirthPlace.City',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'City',
      ShortName: 'Ville',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Ville.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'City',
      ApiField: 'City',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Addressee.BirthPlace.City',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Addressee.BirthPlace.Country',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Country',
      ShortName: 'Pays',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Pays.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Country',
      ApiField: 'Country',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Addressee.BirthPlace.Country',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Addressee.BirthPlace.Geogname',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Geogname',
      ShortName: 'Nom de lieu',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Nom géographique. Références : ead.geogname",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Geogname',
      ApiField: 'Geogname',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Addressee.BirthPlace.Geogname',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Addressee.BirthPlace.PostalCode',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'PostalCode',
      ShortName: 'Code postal',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Code postal.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'PostalCode',
      ApiField: 'PostalCode',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Addressee.BirthPlace.PostalCode',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Addressee.BirthPlace.Region',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Region',
      ShortName: 'Région',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Région.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Region',
      ApiField: 'Region',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Addressee.BirthPlace.Region',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Addressee.Corpname',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Corpname',
      ShortName: "Nom de l'entité",
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Corpname',
      ApiField: 'Corpname',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Addressee.Corpname',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Addressee.DeathDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'DeathDate',
      ShortName: 'date de décès',
      Description: "Mapping : unit-es-mapping.json. Date de décès d'une personne.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'DeathDate',
      ApiField: 'DeathDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Addressee.DeathDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: 'Addressee.DeathPlace',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'DeathPlace',
      ShortName: 'Lieu de décès',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'DeathPlace',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Addressee.DeathPlace',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'Addressee.DeathPlace.Address',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Address',
      ShortName: 'Adresse',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Adresse. Références : ead.address",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Address',
      ApiField: 'Address',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Addressee.DeathPlace.Address',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Addressee.DeathPlace.City',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'City',
      ShortName: 'Ville',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Ville.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'City',
      ApiField: 'City',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Addressee.DeathPlace.City',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Addressee.DeathPlace.Country',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Country',
      ShortName: 'Pays',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Pays.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Country',
      ApiField: 'Country',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Addressee.DeathPlace.Country',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Addressee.DeathPlace.Geogname',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Geogname',
      ShortName: 'Nom de lieu',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Nom géographique. Références : ead.geogname",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Geogname',
      ApiField: 'Geogname',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Addressee.DeathPlace.Geogname',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Addressee.DeathPlace.PostalCode',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'PostalCode',
      ShortName: 'Code postal',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Code postal.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'PostalCode',
      ApiField: 'PostalCode',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Addressee.DeathPlace.PostalCode',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Addressee.DeathPlace.Region',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Region',
      ShortName: 'Région',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Région.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Region',
      ApiField: 'Region',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Addressee.DeathPlace.Region',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Addressee.FirstName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'FirstName',
      ShortName: 'Prénom',
      Description: "Mapping : unit-es-mapping.json. Prénom d'une personne.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'FirstName',
      ApiField: 'FirstName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Addressee.FirstName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Addressee.FullName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'FullName',
      ShortName: 'Nom complet',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'FullName',
      ApiField: 'FullName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Addressee.FullName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Addressee.Function',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Function',
      ShortName: 'Fonction',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Fonction.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Function',
      ApiField: 'Function',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Addressee.Function',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Addressee.Gender',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Gender',
      ShortName: 'Sexe',
      Description: 'Mapping : unit-es-mapping.json. Sexe de la personne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Gender',
      ApiField: 'Gender',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Addressee.Gender',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Addressee.GivenName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'GivenName',
      ShortName: "Nom d'usage",
      Description: "Mapping : unit-es-mapping.json. Nom d'usage d'une personne.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'GivenName',
      ApiField: 'GivenName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Addressee.GivenName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Addressee.Identifier',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Identifier',
      ShortName: 'Identifiant',
      Description:
        "Mapping : unit-es-mapping.json. UNITE ARCHIVISTIQUE : Dans le PersonGroup, Identifiant de type numéro matricule. Dans le EntityGroup, Identifiant de l'entité. REFERENTIELS : identifiant.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Identifier',
      ApiField: 'Identifier',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Addressee.Identifier',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Addressee.Mandate',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Mandate',
      ShortName: 'Droits',
      Description: 'Mapping : unit-es-mapping.json. Mandat octroyé à la personne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Mandate',
      ApiField: 'Mandate',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Addressee.Mandate',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Addressee.Nationality',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Nationality',
      ShortName: 'nationalité',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Nationality',
      ApiField: 'Nationality',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Addressee.Nationality',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Addressee.Position',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Position',
      ShortName: 'Position',
      Description: 'Mapping : unit-es-mapping.json. Intitulé du poste de travail occupé par la personne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Position',
      ApiField: 'Position',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Addressee.Position',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Addressee.Role',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Role',
      ShortName: 'Rôle',
      Description:
        'Mapping : unit-es-mapping.json. Droits avec lesquels un utilisateur a réalisé une opération, notamment dans une application.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Role',
      ApiField: 'Role',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Addressee.Role',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Agent',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'Agent',
      ShortName: 'Agent',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Agent',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Agent',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'Agent.Activity',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Activity',
      ShortName: 'Activité',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Activité.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Activity',
      ApiField: 'Activity',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Agent.Activity',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Agent.BirthDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'BirthDate',
      ShortName: 'Date de naissance',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'BirthDate',
      ApiField: 'BirthDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Agent.BirthDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: 'Agent.BirthName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'BirthName',
      ShortName: 'Nom de naissance',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'BirthName',
      ApiField: 'BirthName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Agent.BirthName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Agent.BirthPlace',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'BirthPlace',
      ShortName: 'Lieu de naissance',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'BirthPlace',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Agent.BirthPlace',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'Agent.BirthPlace.Address',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Address',
      ShortName: 'Adresse',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Adresse. Références : ead.address",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Address',
      ApiField: 'Address',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Agent.BirthPlace.Address',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Agent.BirthPlace.City',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'City',
      ShortName: 'Ville',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Ville.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'City',
      ApiField: 'City',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Agent.BirthPlace.City',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Agent.BirthPlace.Country',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Country',
      ShortName: 'Pays',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Pays.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Country',
      ApiField: 'Country',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Agent.BirthPlace.Country',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Agent.BirthPlace.Geogname',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Geogname',
      ShortName: 'Nom de lieu',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Nom géographique. Références : ead.geogname",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Geogname',
      ApiField: 'Geogname',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Agent.BirthPlace.Geogname',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Agent.BirthPlace.PostalCode',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'PostalCode',
      ShortName: 'Code postal',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Code postal.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'PostalCode',
      ApiField: 'PostalCode',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Agent.BirthPlace.PostalCode',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Agent.BirthPlace.Region',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Region',
      ShortName: 'Région',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Région.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Region',
      ApiField: 'Region',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Agent.BirthPlace.Region',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Agent.Corpname',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Corpname',
      ShortName: "Nom de l'entité",
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Corpname',
      ApiField: 'Corpname',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Agent.Corpname',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Agent.DeathDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'DeathDate',
      ShortName: 'date de décès',
      Description: "Mapping : unit-es-mapping.json. Date de décès d'une personne.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'DeathDate',
      ApiField: 'DeathDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Agent.DeathDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: 'Agent.DeathPlace',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'DeathPlace',
      ShortName: 'Lieu de décès',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'DeathPlace',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Agent.DeathPlace',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'Agent.DeathPlace.Address',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Address',
      ShortName: 'Adresse',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Adresse. Références : ead.address",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Address',
      ApiField: 'Address',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Agent.DeathPlace.Address',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Agent.DeathPlace.City',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'City',
      ShortName: 'Ville',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Ville.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'City',
      ApiField: 'City',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Agent.DeathPlace.City',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Agent.DeathPlace.Country',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Country',
      ShortName: 'Pays',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Pays.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Country',
      ApiField: 'Country',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Agent.DeathPlace.Country',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Agent.DeathPlace.Geogname',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Geogname',
      ShortName: 'Nom de lieu',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Nom géographique. Références : ead.geogname",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Geogname',
      ApiField: 'Geogname',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Agent.DeathPlace.Geogname',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Agent.DeathPlace.PostalCode',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'PostalCode',
      ShortName: 'Code postal',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Code postal.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'PostalCode',
      ApiField: 'PostalCode',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Agent.DeathPlace.PostalCode',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Agent.DeathPlace.Region',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Region',
      ShortName: 'Région',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Région.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Region',
      ApiField: 'Region',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Agent.DeathPlace.Region',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Agent.FirstName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'FirstName',
      ShortName: 'Prénom',
      Description: "Mapping : unit-es-mapping.json. Prénom d'une personne.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'FirstName',
      ApiField: 'FirstName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Agent.FirstName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Agent.FullName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'FullName',
      ShortName: 'Nom complet',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'FullName',
      ApiField: 'FullName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Agent.FullName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Agent.Function',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Function',
      ShortName: 'Fonction',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Fonction.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Function',
      ApiField: 'Function',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Agent.Function',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Agent.Gender',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Gender',
      ShortName: 'Sexe',
      Description: 'Mapping : unit-es-mapping.json. Sexe de la personne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Gender',
      ApiField: 'Gender',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Agent.Gender',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Agent.GivenName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'GivenName',
      ShortName: "Nom d'usage",
      Description: "Mapping : unit-es-mapping.json. Nom d'usage d'une personne.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'GivenName',
      ApiField: 'GivenName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Agent.GivenName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Agent.Identifier',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Identifier',
      ShortName: 'Identifiant',
      Description:
        "Mapping : unit-es-mapping.json. UNITE ARCHIVISTIQUE : Dans le PersonGroup, Identifiant de type numéro matricule. Dans le EntityGroup, Identifiant de l'entité. REFERENTIELS : identifiant.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Identifier',
      ApiField: 'Identifier',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Agent.Identifier',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Agent.Mandate',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Mandate',
      ShortName: 'Droits',
      Description: 'Mapping : unit-es-mapping.json. Mandat octroyé à la personne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Mandate',
      ApiField: 'Mandate',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Agent.Mandate',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Agent.Nationality',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Nationality',
      ShortName: 'nationalité',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Nationality',
      ApiField: 'Nationality',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Agent.Nationality',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Agent.Position',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Position',
      ShortName: 'Position',
      Description: 'Mapping : unit-es-mapping.json. Intitulé du poste de travail occupé par la personne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Position',
      ApiField: 'Position',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Agent.Position',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Agent.Role',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Role',
      ShortName: 'Rôle',
      Description:
        'Mapping : unit-es-mapping.json. Droits avec lesquels un utilisateur a réalisé une opération, notamment dans une application.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Role',
      ApiField: 'Role',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Agent.Role',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'ArchivalAgencyArchiveUnitIdentifier',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'ArchivalAgencyArchiveUnitIdentifier',
      ShortName: "Identifiant attribué par le service d'archives",
      Description:
        "Mapping : unit-es-mapping.json. Identifiant métier attribué à l'ArchiveUnit par le service d'archives. Peut être comparé à une cote.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'ArchivalAgencyArchiveUnitIdentifier',
      ApiField: 'ArchivalAgencyArchiveUnitIdentifier',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'ArchivalAgencyArchiveUnitIdentifier',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'ArchiveUnitProfile',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'ArchiveUnitProfile',
      ShortName: "Profil d'unité archivistique",
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'ArchiveUnitProfile',
      ApiField: 'ArchiveUnitProfile',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: 'ArchiveUnitProfile',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'AuthorizedAgent',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'AuthorizedAgent',
      ShortName: 'Titulaire des droits',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'AuthorizedAgent',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'AuthorizedAgent',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'AuthorizedAgent.Activity',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Activity',
      ShortName: 'Activité',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Activité.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Activity',
      ApiField: 'Activity',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'AuthorizedAgent.Activity',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'AuthorizedAgent.BirthDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'BirthDate',
      ShortName: 'Date de naissance',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'BirthDate',
      ApiField: 'BirthDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'AuthorizedAgent.BirthDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: 'AuthorizedAgent.BirthName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'BirthName',
      ShortName: 'Nom de naissance',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'BirthName',
      ApiField: 'BirthName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'AuthorizedAgent.BirthName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'AuthorizedAgent.BirthPlace',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'BirthPlace',
      ShortName: 'Lieu de naissance',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'BirthPlace',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'AuthorizedAgent.BirthPlace',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'AuthorizedAgent.BirthPlace.Address',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Address',
      ShortName: 'Adresse',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Adresse. Références : ead.address",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Address',
      ApiField: 'Address',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'AuthorizedAgent.BirthPlace.Address',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'AuthorizedAgent.BirthPlace.City',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'City',
      ShortName: 'Ville',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Ville.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'City',
      ApiField: 'City',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'AuthorizedAgent.BirthPlace.City',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'AuthorizedAgent.BirthPlace.Country',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Country',
      ShortName: 'Pays',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Pays.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Country',
      ApiField: 'Country',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'AuthorizedAgent.BirthPlace.Country',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'AuthorizedAgent.BirthPlace.Geogname',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Geogname',
      ShortName: 'Nom de lieu',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Nom géographique. Références : ead.geogname",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Geogname',
      ApiField: 'Geogname',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'AuthorizedAgent.BirthPlace.Geogname',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'AuthorizedAgent.BirthPlace.PostalCode',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'PostalCode',
      ShortName: 'Code postal',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Code postal.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'PostalCode',
      ApiField: 'PostalCode',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'AuthorizedAgent.BirthPlace.PostalCode',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'AuthorizedAgent.BirthPlace.Region',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Region',
      ShortName: 'Région',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Région.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Region',
      ApiField: 'Region',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'AuthorizedAgent.BirthPlace.Region',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'AuthorizedAgent.Corpname',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Corpname',
      ShortName: "Nom de l'entité",
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Corpname',
      ApiField: 'Corpname',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'AuthorizedAgent.Corpname',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'AuthorizedAgent.DeathDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'DeathDate',
      ShortName: 'date de décès',
      Description: "Mapping : unit-es-mapping.json. Date de décès d'une personne.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'DeathDate',
      ApiField: 'DeathDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'AuthorizedAgent.DeathDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: 'AuthorizedAgent.DeathPlace',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'DeathPlace',
      ShortName: 'Lieu de décès',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'DeathPlace',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'AuthorizedAgent.DeathPlace',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'AuthorizedAgent.DeathPlace.Address',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Address',
      ShortName: 'Adresse',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Adresse. Références : ead.address",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Address',
      ApiField: 'Address',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'AuthorizedAgent.DeathPlace.Address',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'AuthorizedAgent.DeathPlace.City',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'City',
      ShortName: 'Ville',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Ville.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'City',
      ApiField: 'City',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'AuthorizedAgent.DeathPlace.City',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'AuthorizedAgent.DeathPlace.Country',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Country',
      ShortName: 'Pays',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Pays.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Country',
      ApiField: 'Country',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'AuthorizedAgent.DeathPlace.Country',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'AuthorizedAgent.DeathPlace.Geogname',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Geogname',
      ShortName: 'Nom de lieu',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Nom géographique. Références : ead.geogname",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Geogname',
      ApiField: 'Geogname',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'AuthorizedAgent.DeathPlace.Geogname',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'AuthorizedAgent.DeathPlace.PostalCode',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'PostalCode',
      ShortName: 'Code postal',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Code postal.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'PostalCode',
      ApiField: 'PostalCode',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'AuthorizedAgent.DeathPlace.PostalCode',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'AuthorizedAgent.DeathPlace.Region',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Region',
      ShortName: 'Région',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Région.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Region',
      ApiField: 'Region',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'AuthorizedAgent.DeathPlace.Region',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'AuthorizedAgent.FirstName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'FirstName',
      ShortName: 'Prénom',
      Description: "Mapping : unit-es-mapping.json. Prénom d'une personne.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'FirstName',
      ApiField: 'FirstName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'AuthorizedAgent.FirstName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'AuthorizedAgent.FullName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'FullName',
      ShortName: 'Nom complet',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'FullName',
      ApiField: 'FullName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'AuthorizedAgent.FullName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'AuthorizedAgent.Function',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Function',
      ShortName: 'Fonction',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Fonction.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Function',
      ApiField: 'Function',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'AuthorizedAgent.Function',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'AuthorizedAgent.Gender',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Gender',
      ShortName: 'Sexe',
      Description: 'Mapping : unit-es-mapping.json. Sexe de la personne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Gender',
      ApiField: 'Gender',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'AuthorizedAgent.Gender',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'AuthorizedAgent.GivenName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'GivenName',
      ShortName: "Nom d'usage",
      Description: "Mapping : unit-es-mapping.json. Nom d'usage d'une personne.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'GivenName',
      ApiField: 'GivenName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'AuthorizedAgent.GivenName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'AuthorizedAgent.Identifier',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Identifier',
      ShortName: 'Identifiant',
      Description:
        "Mapping : unit-es-mapping.json. UNITE ARCHIVISTIQUE : Dans le PersonGroup, Identifiant de type numéro matricule. Dans le EntityGroup, Identifiant de l'entité. REFERENTIELS : identifiant.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Identifier',
      ApiField: 'Identifier',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'AuthorizedAgent.Identifier',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'AuthorizedAgent.Mandate',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Mandate',
      ShortName: 'Droits',
      Description: 'Mapping : unit-es-mapping.json. Mandat octroyé à la personne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Mandate',
      ApiField: 'Mandate',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'AuthorizedAgent.Mandate',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'AuthorizedAgent.Nationality',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Nationality',
      ShortName: 'nationalité',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Nationality',
      ApiField: 'Nationality',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'AuthorizedAgent.Nationality',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'AuthorizedAgent.Position',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Position',
      ShortName: 'Position',
      Description: 'Mapping : unit-es-mapping.json. Intitulé du poste de travail occupé par la personne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Position',
      ApiField: 'Position',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'AuthorizedAgent.Position',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'AuthorizedAgent.Role',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Role',
      ShortName: 'Rôle',
      Description:
        'Mapping : unit-es-mapping.json. Droits avec lesquels un utilisateur a réalisé une opération, notamment dans une application.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Role',
      ApiField: 'Role',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'AuthorizedAgent.Role',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Coverage',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'Coverage',
      ShortName: 'Couverture(s)',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Coverage',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Coverage',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'Coverage.Juridictional',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Juridictional',
      ShortName: 'Couverture juridictionnelle',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Juridictional',
      ApiField: 'Juridictional',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Coverage.Juridictional',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Coverage.Spatial',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Spatial',
      ShortName: 'Couverture spatiale',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Spatial',
      ApiField: 'Spatial',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Coverage.Spatial',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Coverage.Temporal',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Temporal',
      ShortName: 'Couverture temporelle',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Temporal',
      ApiField: 'Temporal',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Coverage.Temporal',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'CreatedDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'CreatedDate',
      ShortName: 'Date de création',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'CreatedDate',
      ApiField: 'CreatedDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'CreatedDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: 'CustodialHistory',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'CustodialHistory',
      ShortName: 'Historique de la conservation',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'CustodialHistory',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'CustodialHistory',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'CustodialHistory.CustodialHistoryFile',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'CustodialHistoryFile',
      ShortName: 'Référence à un journal externe',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'CustodialHistoryFile',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'CustodialHistory.CustodialHistoryFile',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'CustodialHistory.CustodialHistoryFile.DataObjectGroupReferenceId',
      StringSize: 'SHORT',
      Cardinality: 'ONE_REQUIRED',
      FieldName: 'DataObjectGroupReferenceId',
      ShortName: "Référence à un groupe d'objets",
      Description: "Mapping : unit-es-mapping.json. Référence à un groupe d'objets-données listé dans les métadonnées de transport.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'DataObjectGroupReferenceId',
      ApiField: 'DataObjectGroupReferenceId',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'CustodialHistory.CustodialHistoryFile.DataObjectGroupReferenceId',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'CustodialHistory.CustodialHistoryFile.DataObjectReferenceId',
      StringSize: 'SHORT',
      Cardinality: 'ONE_REQUIRED',
      FieldName: 'DataObjectReferenceId',
      ShortName: 'Référence à un objet',
      Description: "Mapping : unit-es-mapping.json. Référence à un objet-données ou à un groupe d'objets-données interne(s).",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'DataObjectReferenceId',
      ApiField: 'DataObjectReferenceId',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'CustodialHistory.CustodialHistoryFile.DataObjectReferenceId',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'CustodialHistory.CustodialHistoryItem',
      StringSize: 'LARGE',
      Cardinality: 'MANY_REQUIRED',
      FieldName: 'CustodialHistoryItem',
      ShortName: 'Détail',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'CustodialHistoryItem',
      ApiField: 'CustodialHistoryItem',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'CustodialHistory.CustodialHistoryItem',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'DateLitteral',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'DateLitteral',
      ShortName: 'Date textuelle',
      Description: 'Mapping : unit-es-mapping.json. DateLitteral',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'DateLitteral',
      ApiField: 'DateLitteral',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'DateLitteral',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Description',
      StringSize: 'LARGE',
      Cardinality: 'ONE',
      FieldName: 'Description',
      ShortName: 'Description',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Description',
      ApiField: 'Description',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Description',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'DescriptionLanguage',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'DescriptionLanguage',
      ShortName: 'Langue de la description',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'DescriptionLanguage',
      ApiField: 'DescriptionLanguage',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'DescriptionLanguage',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'DescriptionLevel',
      StringSize: null,
      Cardinality: 'ONE_REQUIRED',
      FieldName: 'DescriptionLevel',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      ApiField: 'DescriptionLevel',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'DescriptionLevel',
      DataType: 'STRING',
      SedaField: 'DescriptionLevel',
      ShortName: 'Niveau de description',
    },
    {
      id: null,
      Path: 'Description_',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'Description_',
      ShortName: 'Description',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Description_',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Description_',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'DocumentType',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'DocumentType',
      ShortName: 'Type de document',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'DocumentType',
      ApiField: 'DocumentType',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'DocumentType',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'EndDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'EndDate',
      ShortName: 'Date de fin',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'EndDate',
      ApiField: 'EndDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'EndDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: 'Event',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'Event',
      ShortName: 'Événement',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Event',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Event',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'Event.evDateTime',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'evDateTime',
      ShortName: 'Date',
      Description: 'Mapping : logbook-es-mapping.json. Date de lancement de l’opération',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'EventDateTime',
      ApiField: 'evDateTime',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Event.evDateTime',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: 'Event.evDetData',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'evDetData',
      ShortName: "Message technique détaillant l'événement",
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'eventDetailData',
      ApiField: 'evDetData',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Event.evDetData',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Event.evId',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'evId',
      ShortName: 'Identifiant',
      Description: 'Mapping : logbook-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'EventIdentifier',
      ApiField: 'evId',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Event.evId',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Event.evType',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'evType',
      ShortName: 'Type',
      Description: 'Mapping : logbook-es-mapping.json. Code du type de l’opération',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'EventType',
      ApiField: 'evType',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Event.evType',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Event.evTypeDetail',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'evTypeDetail',
      ShortName: 'Détail de l’événement',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'EventDetail',
      ApiField: 'evTypeDetail',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Event.evTypeDetail',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Event.evTypeProc',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'evTypeProc',
      ShortName: 'Code',
      Description: "Mapping : logbook-es-mapping.json. Type de processus. Equivaut à la traduction du code du type de l'opération.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'EventTypeCode',
      ApiField: 'evTypeProc',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Event.evTypeProc',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Event.outDetail',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'outDetail',
      ShortName: 'Détail sur le résultat',
      Description: 'Mapping : logbook-es-mapping.json. Code correspondant au résultat de l’événement.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'OutcomeDetail',
      ApiField: 'outDetail',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Event.outDetail',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Event.outMessg',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'outMessg',
      ShortName: "Description détaillée de l'événement",
      Description: 'Mapping : logbook-es-mapping.json. Détail du résultat de l’événement.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'OutcomeDetailMessage',
      ApiField: 'outMessg',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Event.outMessg',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Event.outcome',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'outcome',
      ShortName: 'Résultat',
      Description: 'Mapping : logbook-es-mapping.json. Statut de l’événement',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Outcome',
      ApiField: 'outcome',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Event.outcome',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Event.LinkingAgentIdentifier',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'LinkingAgentIdentifier',
      ShortName: 'Agent',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'LinkingAgentIdentifier',
      ApiField: 'linkingAgentIdentifier',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Event.linkingAgentIdentifier',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'Event.LinkingAgentIdentifier.LinkingAgentIdentifierType',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'LinkingAgentIdentifierType',
      ShortName: 'Identifiant',
      Description: 'Mapping : unit-es-mapping.json. LinkingAgentIdentifierType ',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'LinkingAgentIdentifierType',
      ApiField: 'LinkingAgentIdentifierType',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Event.linkingAgentIdentifier.LinkingAgentIdentifierType',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Event.LinkingAgentIdentifier.LinkingAgentIdentifierValue',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'LinkingAgentIdentifierValue',
      ShortName: 'Valeur',
      Description: 'Mapping : unit-es-mapping.json. LinkingAgentIdentifierValue',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'LinkingAgentIdentifierValue',
      ApiField: 'LinkingAgentIdentifierValue',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Event.linkingAgentIdentifier.LinkingAgentIdentifierValue',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Event.LinkingAgentIdentifier.LinkingAgentRole',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'LinkingAgentRole',
      ShortName: 'Rôle',
      Description: 'Mapping : unit-es-mapping.json. LinkingAgentRole',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'LinkingAgentRole',
      ApiField: 'LinkingAgentRole',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Event.linkingAgentIdentifier.LinkingAgentRole',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'FilePlanPosition',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'FilePlanPosition',
      ShortName: 'Position dans le plan de classement',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'FilePlanPosition',
      ApiField: 'FilePlanPosition',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'FilePlanPosition',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Gps',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'Gps',
      ShortName: 'Coordonnées GPS',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Gps',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Gps',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'Gps.GpsAltitude',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'GpsAltitude',
      ShortName: 'Altitude',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'GpsAltitude',
      ApiField: 'GpsAltitude',
      Type: 'LONG',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Gps.GpsAltitude',
      DataType: 'LONG',
    },
    {
      id: null,
      Path: 'Gps.GpsAltitudeRef',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'GpsAltitudeRef',
      ShortName: 'Référence de l’altitude',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'GpsAltitudeRef',
      ApiField: 'GpsAltitudeRef',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Gps.GpsAltitudeRef',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Gps.GpsDateStamp',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'GpsDateStamp',
      ShortName: 'Heure et date de la position',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'GpsDateStamp',
      ApiField: 'GpsDateStamp',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Gps.GpsDateStamp',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Gps.GpsLatitude',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'GpsLatitude',
      ShortName: 'Latitude',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'GpsLatitude',
      ApiField: 'GpsLatitude',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Gps.GpsLatitude',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Gps.GpsLatitudeRef',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'GpsLatitudeRef',
      ShortName: 'Référence de la latitude',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'GpsLatitudeRef',
      ApiField: 'GpsLatitudeRef',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Gps.GpsLatitudeRef',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Gps.GpsLongitude',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'GpsLongitude',
      ShortName: 'Longitude',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'GpsLongitude',
      ApiField: 'GpsLongitude',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Gps.GpsLongitude',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Gps.GpsLongitudeRef',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'GpsLongitudeRef',
      ShortName: 'Référence de la longitude',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'GpsLongitudeRef',
      ApiField: 'GpsLongitudeRef',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Gps.GpsLongitudeRef',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Gps.GpsVersionID',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'GpsVersionID',
      ShortName: 'Identifiant de version du GPS',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'GpsVersionID',
      ApiField: 'GpsVersionID',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Gps.GpsVersionID',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Keyword',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'Keyword',
      ShortName: 'Mot-clé',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Keyword',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Keyword',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'Keyword.KeywordContent',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'KeywordContent',
      ShortName: 'Valeur du mot-clé',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'KeywordContent',
      ApiField: 'KeywordContent',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Keyword.KeywordContent',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Keyword.KeywordReference',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'KeywordReference',
      ShortName: 'Référence du mot-clé',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'KeywordReference',
      ApiField: 'KeywordReference',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Keyword.KeywordReference',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Keyword.KeywordType',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'KeywordType',
      ShortName: 'Type de mot-clé',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'KeywordType',
      ApiField: 'KeywordType',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Keyword.KeywordType',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Language',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Language',
      ShortName: 'Langue',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Language',
      ApiField: 'Language',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Language',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'OriginatingAgency',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'OriginatingAgency',
      ShortName: 'Service producteur',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'OriginatingAgencyIdentifier',
      ApiField: 'OriginatingAgency',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'OriginatingAgency',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'OriginatingAgency.Identifier',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Identifier',
      ShortName: 'Identifiant du service producteur',
      Description:
        "Mapping : unit-es-mapping.json. UNITE ARCHIVISTIQUE : Dans le PersonGroup, Identifiant de type numéro matricule. Dans le EntityGroup, Identifiant de l'entité. REFERENTIELS : identifiant.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Identifier',
      ApiField: 'Identifier',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'OriginatingAgency.Identifier',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'OriginatingAgency.OrganizationDescriptiveMetadata',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'OrganizationDescriptiveMetadata',
      ShortName: 'OrganizationDescriptiveMetadata',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'OrganizationDescriptiveMetadata',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'OriginatingAgency.OrganizationDescriptiveMetadata',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'OriginatingAgencyArchiveUnitIdentifier',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'OriginatingAgencyArchiveUnitIdentifier',
      ShortName: 'Identifiant attribué par le service producteur',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'OriginatingAgencyArchiveUnitIdentifier',
      ApiField: 'OriginatingAgencyArchiveUnitIdentifier',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'OriginatingAgencyArchiveUnitIdentifier',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'OriginatingSystemId',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'OriginatingSystemId',
      ShortName: "Identifiant attribué par le système d'origine",
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'OriginatingSystemId',
      ApiField: 'OriginatingSystemId',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'OriginatingSystemId',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'OriginatingSystemIdReplyTo',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'OriginatingSystemIdReplyTo',
      ShortName: 'Réponse au message en référence',
      Description: 'Mapping : unit-es-mapping.json. OriginatingSystemIdReplyTo',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'OriginatingSystemIdReplyTo',
      ApiField: 'OriginatingSystemIdReplyTo',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'OriginatingSystemIdReplyTo',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'PersistentIdentifier',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'PersistentIdentifier',
      ShortName: 'Identifiant pérenne',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'PersistentIdentifier',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'PersistentIdentifier',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'PersistentIdentifier.PersistentIdentifierContent',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'PersistentIdentifierContent',
      ShortName: 'Identifiant',
      Description: 'Persistent Identifier Content',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'PersistentIdentifierContent',
      ApiField: 'PersistentIdentifierContent',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'PersistentIdentifier.PersistentIdentifierContent',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'PersistentIdentifier.PersistentIdentifierOrigin',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'PersistentIdentifierOrigin',
      ShortName: 'Origine',
      Description: 'Persistent Identifier Origin',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'PersistentIdentifierOrigin',
      ApiField: 'PersistentIdentifierOrigin',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'PersistentIdentifier.PersistentIdentifierOrigin',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'PersistentIdentifier.PersistentIdentifierReference',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'PersistentIdentifierReference',
      ShortName: 'Référence',
      Description: 'Persistent Identifier Reference',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'PersistentIdentifierReference',
      ApiField: 'PersistentIdentifierReference',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'PersistentIdentifier.PersistentIdentifierReference',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'PersistentIdentifier.PersistentIdentifierType',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'PersistentIdentifierType',
      ShortName: 'Type',
      Description: 'Persistent Identifier Type',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'PersistentIdentifierType',
      ApiField: 'PersistentIdentifierType',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'PersistentIdentifier.PersistentIdentifierType',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'ReceivedDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'ReceivedDate',
      ShortName: 'Date de réception',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'ReceivedDate',
      ApiField: 'ReceivedDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'ReceivedDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: 'Recipient',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'Recipient',
      ShortName: 'Destinataire pour information',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Recipient',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Recipient',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'Recipient.Activity',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Activity',
      ShortName: 'Activité',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Activité.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Activity',
      ApiField: 'Activity',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Recipient.Activity',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Recipient.BirthDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'BirthDate',
      ShortName: 'Date de naissance',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'BirthDate',
      ApiField: 'BirthDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Recipient.BirthDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: 'Recipient.BirthName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'BirthName',
      ShortName: 'Nom de naissance',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'BirthName',
      ApiField: 'BirthName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Recipient.BirthName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Recipient.BirthPlace',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'BirthPlace',
      ShortName: 'Lieu de naissance',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'BirthPlace',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Recipient.BirthPlace',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'Recipient.BirthPlace.Address',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Address',
      ShortName: 'Adresse',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Adresse. Références : ead.address",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Address',
      ApiField: 'Address',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Recipient.BirthPlace.Address',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Recipient.BirthPlace.City',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'City',
      ShortName: 'Ville',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Ville.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'City',
      ApiField: 'City',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Recipient.BirthPlace.City',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Recipient.BirthPlace.Country',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Country',
      ShortName: 'Pays',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Pays.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Country',
      ApiField: 'Country',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Recipient.BirthPlace.Country',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Recipient.BirthPlace.Geogname',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Geogname',
      ShortName: 'Nom de lieu',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Nom géographique. Références : ead.geogname",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Geogname',
      ApiField: 'Geogname',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Recipient.BirthPlace.Geogname',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Recipient.BirthPlace.PostalCode',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'PostalCode',
      ShortName: 'Code postal',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Code postal.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'PostalCode',
      ApiField: 'PostalCode',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Recipient.BirthPlace.PostalCode',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Recipient.BirthPlace.Region',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Region',
      ShortName: 'Région',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Région.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Region',
      ApiField: 'Region',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Recipient.BirthPlace.Region',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Recipient.Corpname',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Corpname',
      ShortName: "Nom de l'entité",
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Corpname',
      ApiField: 'Corpname',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Recipient.Corpname',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Recipient.DeathDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'DeathDate',
      ShortName: 'date de décès',
      Description: "Mapping : unit-es-mapping.json. Date de décès d'une personne.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'DeathDate',
      ApiField: 'DeathDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Recipient.DeathDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: 'Recipient.DeathPlace',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'DeathPlace',
      ShortName: 'Lieu de décès',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'DeathPlace',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Recipient.DeathPlace',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'Recipient.DeathPlace.Address',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Address',
      ShortName: 'Adresse',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Adresse. Références : ead.address",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Address',
      ApiField: 'Address',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Recipient.DeathPlace.Address',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Recipient.DeathPlace.City',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'City',
      ShortName: 'Ville',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Ville.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'City',
      ApiField: 'City',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Recipient.DeathPlace.City',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Recipient.DeathPlace.Country',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Country',
      ShortName: 'Pays',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Pays.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Country',
      ApiField: 'Country',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Recipient.DeathPlace.Country',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Recipient.DeathPlace.Geogname',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Geogname',
      ShortName: 'Nom de lieu',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Nom géographique. Références : ead.geogname",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Geogname',
      ApiField: 'Geogname',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Recipient.DeathPlace.Geogname',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Recipient.DeathPlace.PostalCode',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'PostalCode',
      ShortName: 'Code postal',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Code postal.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'PostalCode',
      ApiField: 'PostalCode',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Recipient.DeathPlace.PostalCode',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Recipient.DeathPlace.Region',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Region',
      ShortName: 'Région',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Région.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Region',
      ApiField: 'Region',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Recipient.DeathPlace.Region',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Recipient.FirstName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'FirstName',
      ShortName: 'Prénom',
      Description: "Mapping : unit-es-mapping.json. Prénom d'une personne.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'FirstName',
      ApiField: 'FirstName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Recipient.FirstName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Recipient.FullName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'FullName',
      ShortName: 'Nom complet',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'FullName',
      ApiField: 'FullName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Recipient.FullName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Recipient.Function',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Function',
      ShortName: 'Fonction',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Fonction.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Function',
      ApiField: 'Function',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Recipient.Function',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Recipient.Gender',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Gender',
      ShortName: 'Sexe',
      Description: 'Mapping : unit-es-mapping.json. Sexe de la personne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Gender',
      ApiField: 'Gender',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Recipient.Gender',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Recipient.GivenName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'GivenName',
      ShortName: "Nom d'usage",
      Description: "Mapping : unit-es-mapping.json. Nom d'usage d'une personne.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'GivenName',
      ApiField: 'GivenName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Recipient.GivenName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Recipient.Identifier',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Identifier',
      ShortName: 'Identifiant',
      Description:
        "Mapping : unit-es-mapping.json. UNITE ARCHIVISTIQUE : Dans le PersonGroup, Identifiant de type numéro matricule. Dans le EntityGroup, Identifiant de l'entité. REFERENTIELS : identifiant.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Identifier',
      ApiField: 'Identifier',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Recipient.Identifier',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Recipient.Mandate',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Mandate',
      ShortName: 'Droits',
      Description: 'Mapping : unit-es-mapping.json. Mandat octroyé à la personne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Mandate',
      ApiField: 'Mandate',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Recipient.Mandate',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Recipient.Nationality',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Nationality',
      ShortName: 'nationalité',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Nationality',
      ApiField: 'Nationality',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Recipient.Nationality',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Recipient.Position',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Position',
      ShortName: 'Position',
      Description: 'Mapping : unit-es-mapping.json. Intitulé du poste de travail occupé par la personne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Position',
      ApiField: 'Position',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Recipient.Position',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Recipient.Role',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Role',
      ShortName: 'Rôle',
      Description:
        'Mapping : unit-es-mapping.json. Droits avec lesquels un utilisateur a réalisé une opération, notamment dans une application.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Role',
      ApiField: 'Role',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Recipient.Role',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'RegisteredDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'RegisteredDate',
      ShortName: 'Date d’enregistrement',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'RegisteredDate',
      ApiField: 'RegisteredDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RegisteredDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: 'RelatedObjectReference',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'RelatedObjectReference',
      ShortName: 'Référence(s)',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'RelatedObjectReference',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.IsPartOf',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'IsPartOf',
      ShortName: 'Est une partie de',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'IsPartOf',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.IsPartOf',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.IsPartOf.ArchiveUnitRefId',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'ArchiveUnitRefId',
      ShortName: 'Unité',
      Description: 'Mapping : unit-es-mapping.json. Référence à une ArchiveUnit interne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'ArchiveUnitRefId',
      ApiField: 'ArchiveUnitRefId',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.IsPartOf.ArchiveUnitRefId',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.IsPartOf.DataObjectReference',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'DataObjectReference',
      ShortName: 'Objet',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'DataObjectReference',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.IsPartOf.DataObjectReference',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.IsPartOf.DataObjectReference.DataObjectGroupReferenceId',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'DataObjectGroupReferenceId',
      ShortName: "ID du groupe d'objets",
      Description: "Mapping : unit-es-mapping.json. Référence à un groupe d'objets-données listé dans les métadonnées de transport.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'DataObjectGroupReferenceId',
      ApiField: 'DataObjectGroupReferenceId',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.IsPartOf.DataObjectReference.DataObjectGroupReferenceId',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.IsPartOf.DataObjectReference.DataObjectReferenceId',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'DataObjectReferenceId',
      ShortName: "ID de l'objet",
      Description: "Mapping : unit-es-mapping.json. Référence à un objet-données ou à un groupe d'objets-données interne(s).",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'DataObjectReferenceId',
      ApiField: 'DataObjectReferenceId',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.IsPartOf.DataObjectReference.DataObjectReferenceId',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.IsPartOf.ExternalReference',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'ExternalReference',
      ShortName: 'Unité déjà archivée',
      Description: 'Mapping : unit-es-mapping.json. Référence à un objet externe, présent ni dans le message, ni dans le SAE',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'ExternalReference',
      ApiField: 'ExternalReference',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.IsPartOf.ExternalReference',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.IsPartOf.RepositoryArchiveUnitPID',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'RepositoryArchiveUnitPID',
      ShortName: 'Objet déjà archivé',
      Description: "Mapping : unit-es-mapping.json. Référence à un ArchiveUnit déjà conservé dans un système d'archivage.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'RepositoryArchiveUnitPID',
      ApiField: 'RepositoryArchiveUnitPID',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.IsPartOf.RepositoryArchiveUnitPID',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.IsPartOf.RepositoryObjectPID',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'RepositoryObjectPID',
      ShortName: 'Référence externe',
      Description:
        "Mapping : unit-es-mapping.json. Référence à un un objet-données ou à un groupe d'objets-données déjà conservé(s) dans un système d'archivage.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'RepositoryObjectPID',
      ApiField: 'RepositoryObjectPID',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.IsPartOf.RepositoryObjectPID',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.IsVersionOf',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'IsVersionOf',
      ShortName: 'Est une version de',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'IsVersionOf',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.IsVersionOf',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.IsVersionOf.ArchiveUnitRefId',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'ArchiveUnitRefId',
      ShortName: 'Unité',
      Description: 'Mapping : unit-es-mapping.json. Référence à une ArchiveUnit interne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'ArchiveUnitRefId',
      ApiField: 'ArchiveUnitRefId',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.IsVersionOf.ArchiveUnitRefId',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.IsVersionOf.DataObjectReference',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'DataObjectReference',
      ShortName: 'Objet',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'DataObjectReference',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.IsVersionOf.DataObjectReference',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.IsVersionOf.DataObjectReference.DataObjectGroupReferenceId',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'DataObjectGroupReferenceId',
      ShortName: "ID du groupe d'objets",
      Description: "Mapping : unit-es-mapping.json. Référence à un groupe d'objets-données listé dans les métadonnées de transport.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'DataObjectGroupReferenceId',
      ApiField: 'DataObjectGroupReferenceId',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.IsVersionOf.DataObjectReference.DataObjectGroupReferenceId',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.IsVersionOf.DataObjectReference.DataObjectReferenceId',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'DataObjectReferenceId',
      ShortName: "ID de l'objet",
      Description: "Mapping : unit-es-mapping.json. Référence à un objet-données ou à un groupe d'objets-données interne(s).",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'DataObjectReferenceId',
      ApiField: 'DataObjectReferenceId',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.IsVersionOf.DataObjectReference.DataObjectReferenceId',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.IsVersionOf.ExternalReference',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'ExternalReference',
      ShortName: 'Référence externe',
      Description: 'Mapping : unit-es-mapping.json. Référence à un objet externe, présent ni dans le message, ni dans le SAE',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'ExternalReference',
      ApiField: 'ExternalReference',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.IsVersionOf.ExternalReference',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.IsVersionOf.RepositoryArchiveUnitPID',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'RepositoryArchiveUnitPID',
      ShortName: 'Unité déjà archivée',
      Description: "Mapping : unit-es-mapping.json. Référence à un ArchiveUnit déjà conservé dans un système d'archivage.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'RepositoryArchiveUnitPID',
      ApiField: 'RepositoryArchiveUnitPID',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.IsVersionOf.RepositoryArchiveUnitPID',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.IsVersionOf.RepositoryObjectPID',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'RepositoryObjectPID',
      ShortName: 'Objet déjà archivé',
      Description:
        "Mapping : unit-es-mapping.json. Référence à un un objet-données ou à un groupe d'objets-données déjà conservé(s) dans un système d'archivage.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'RepositoryObjectPID',
      ApiField: 'RepositoryObjectPID',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.IsVersionOf.RepositoryObjectPID',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.References',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'References',
      ShortName: 'References',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'References',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.References',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.References.ArchiveUnitRefId',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'ArchiveUnitRefId',
      ShortName: 'Référence à une ArchiveUnit interne',
      Description: 'Mapping : unit-es-mapping.json. Référence à une ArchiveUnit interne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'ArchiveUnitRefId',
      ApiField: 'ArchiveUnitRefId',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.References.ArchiveUnitRefId',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.References.DataObjectReference',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'DataObjectReference',
      ShortName: 'DataObjectReference',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'DataObjectReference',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.References.DataObjectReference',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.References.DataObjectReference.DataObjectGroupReferenceId',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'DataObjectGroupReferenceId',
      ShortName: "Référence à un groupe d'objets",
      Description: "Mapping : unit-es-mapping.json. Référence à un groupe d'objets-données listé dans les métadonnées de transport.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'DataObjectGroupReferenceId',
      ApiField: 'DataObjectGroupReferenceId',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.References.DataObjectReference.DataObjectGroupReferenceId',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.References.DataObjectReference.DataObjectReferenceId',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'DataObjectReferenceId',
      ShortName: "Référence à un objet ou à un groupe d'objets interne(s)",
      Description: "Mapping : unit-es-mapping.json. Référence à un objet-données ou à un groupe d'objets-données interne(s).",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'DataObjectReferenceId',
      ApiField: 'DataObjectReferenceId',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.References.DataObjectReference.DataObjectReferenceId',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.References.ExternalReference',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'ExternalReference',
      ShortName: 'Référence à un objet externe, présent ni dans le message, ni dans le SAE',
      Description: 'Mapping : unit-es-mapping.json. Référence à un objet externe, présent ni dans le message, ni dans le SAE',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'ExternalReference',
      ApiField: 'ExternalReference',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.References.ExternalReference',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.References.RepositoryArchiveUnitPID',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'RepositoryArchiveUnitPID',
      ShortName: 'Référence à une ArchiveUnit déjà conservée',
      Description: "Mapping : unit-es-mapping.json. Référence à un ArchiveUnit déjà conservé dans un système d'archivage.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'RepositoryArchiveUnitPID',
      ApiField: 'RepositoryArchiveUnitPID',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.References.RepositoryArchiveUnitPID',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.References.RepositoryObjectPID',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'RepositoryObjectPID',
      ShortName: "Référence à un objet ou à un groupe d'objets déjà conservé(s)",
      Description:
        "Mapping : unit-es-mapping.json. Référence à un un objet-données ou à un groupe d'objets-données déjà conservé(s) dans un système d'archivage.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'RepositoryObjectPID',
      ApiField: 'RepositoryObjectPID',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.References.RepositoryObjectPID',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.Replaces',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'Replaces',
      ShortName: 'Remplace',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Replaces',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.Replaces',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.Replaces.ArchiveUnitRefId',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'ArchiveUnitRefId',
      ShortName: 'Unité',
      Description: 'Mapping : unit-es-mapping.json. Référence à une ArchiveUnit interne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'ArchiveUnitRefId',
      ApiField: 'ArchiveUnitRefId',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.Replaces.ArchiveUnitRefId',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.Replaces.DataObjectReference',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'DataObjectReference',
      ShortName: 'Objet',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'DataObjectReference',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.Replaces.DataObjectReference',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.Replaces.DataObjectReference.DataObjectGroupReferenceId',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'DataObjectGroupReferenceId',
      ShortName: "ID du groupe d'objets",
      Description: "Mapping : unit-es-mapping.json. Référence à un groupe d'objets-données listé dans les métadonnées de transport.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'DataObjectGroupReferenceId',
      ApiField: 'DataObjectGroupReferenceId',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.Replaces.DataObjectReference.DataObjectGroupReferenceId',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.Replaces.DataObjectReference.DataObjectReferenceId',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'DataObjectReferenceId',
      ShortName: "ID de l'objet",
      Description: "Mapping : unit-es-mapping.json. Référence à un objet-données ou à un groupe d'objets-données interne(s).",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'DataObjectReferenceId',
      ApiField: 'DataObjectReferenceId',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.Replaces.DataObjectReference.DataObjectReferenceId',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.Replaces.ExternalReference',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'ExternalReference',
      ShortName: 'Unité déjà archivée',
      Description: 'Mapping : unit-es-mapping.json. Référence à un objet externe, présent ni dans le message, ni dans le SAE',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'ExternalReference',
      ApiField: 'ExternalReference',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.Replaces.ExternalReference',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.Replaces.RepositoryArchiveUnitPID',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'RepositoryArchiveUnitPID',
      ShortName: 'Objet déjà archivé',
      Description: "Mapping : unit-es-mapping.json. Référence à un ArchiveUnit déjà conservé dans un système d'archivage.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'RepositoryArchiveUnitPID',
      ApiField: 'RepositoryArchiveUnitPID',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.Replaces.RepositoryArchiveUnitPID',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.Replaces.RepositoryObjectPID',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'RepositoryObjectPID',
      ShortName: 'Référence externe',
      Description:
        "Mapping : unit-es-mapping.json. Référence à un un objet-données ou à un groupe d'objets-données déjà conservé(s) dans un système d'archivage.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'RepositoryObjectPID',
      ApiField: 'RepositoryObjectPID',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.Replaces.RepositoryObjectPID',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.Requires',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'Requires',
      ShortName: 'Requiert',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Requires',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.Requires',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.Requires.ArchiveUnitRefId',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'ArchiveUnitRefId',
      ShortName: 'Unité',
      Description: 'Mapping : unit-es-mapping.json. Référence à une ArchiveUnit interne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'ArchiveUnitRefId',
      ApiField: 'ArchiveUnitRefId',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.Requires.ArchiveUnitRefId',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.Requires.DataObjectReference',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'DataObjectReference',
      ShortName: 'Objet',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'DataObjectReference',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.Requires.DataObjectReference',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.Requires.DataObjectReference.DataObjectGroupReferenceId',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'DataObjectGroupReferenceId',
      ShortName: "ID du groupe d'objets",
      Description: "Mapping : unit-es-mapping.json. Référence à un groupe d'objets-données listé dans les métadonnées de transport.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'DataObjectGroupReferenceId',
      ApiField: 'DataObjectGroupReferenceId',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.Requires.DataObjectReference.DataObjectGroupReferenceId',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.Requires.DataObjectReference.DataObjectReferenceId',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'DataObjectReferenceId',
      ShortName: "ID de l'objet",
      Description: "Mapping : unit-es-mapping.json. Référence à un objet-données ou à un groupe d'objets-données interne(s).",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'DataObjectReferenceId',
      ApiField: 'DataObjectReferenceId',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.Requires.DataObjectReference.DataObjectReferenceId',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.Requires.ExternalReference',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'ExternalReference',
      ShortName: 'Unité déjà archivée',
      Description: 'Mapping : unit-es-mapping.json. Référence à un objet externe, présent ni dans le message, ni dans le SAE',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'ExternalReference',
      ApiField: 'ExternalReference',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.Requires.ExternalReference',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.Requires.RepositoryArchiveUnitPID',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'RepositoryArchiveUnitPID',
      ShortName: 'Objet déjà archivé',
      Description: "Mapping : unit-es-mapping.json. Référence à un ArchiveUnit déjà conservé dans un système d'archivage.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'RepositoryArchiveUnitPID',
      ApiField: 'RepositoryArchiveUnitPID',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.Requires.RepositoryArchiveUnitPID',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'RelatedObjectReference.Requires.RepositoryObjectPID',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'RepositoryObjectPID',
      ShortName: 'Référence externe',
      Description:
        "Mapping : unit-es-mapping.json. Référence à un un objet-données ou à un groupe d'objets-données déjà conservé(s) dans un système d'archivage.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'RepositoryObjectPID',
      ApiField: 'RepositoryObjectPID',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'RelatedObjectReference.Requires.RepositoryObjectPID',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Sender',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'Sender',
      ShortName: 'Expéditeur',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Sender',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Sender',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'Sender.Activity',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Activity',
      ShortName: 'Activité',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Activité.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Activity',
      ApiField: 'Activity',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Sender.Activity',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Sender.BirthDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'BirthDate',
      ShortName: 'Date de naissance',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'BirthDate',
      ApiField: 'BirthDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Sender.BirthDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: 'Sender.BirthName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'BirthName',
      ShortName: 'Nom de naissance',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'BirthName',
      ApiField: 'BirthName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Sender.BirthName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Sender.BirthPlace',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'BirthPlace',
      ShortName: 'Lieu de naissance',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'BirthPlace',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Sender.BirthPlace',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'Sender.BirthPlace.Address',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Address',
      ShortName: 'Adresse',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Adresse. Références : ead.address",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Address',
      ApiField: 'Address',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Sender.BirthPlace.Address',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Sender.BirthPlace.City',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'City',
      ShortName: 'Ville',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Ville.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'City',
      ApiField: 'City',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Sender.BirthPlace.City',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Sender.BirthPlace.Country',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Country',
      ShortName: 'Pays',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Pays.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Country',
      ApiField: 'Country',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Sender.BirthPlace.Country',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Sender.BirthPlace.Geogname',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Geogname',
      ShortName: 'Nom de lieu',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Nom géographique. Références : ead.geogname",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Geogname',
      ApiField: 'Geogname',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Sender.BirthPlace.Geogname',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Sender.BirthPlace.PostalCode',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'PostalCode',
      ShortName: 'Code postal',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Code postal.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'PostalCode',
      ApiField: 'PostalCode',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Sender.BirthPlace.PostalCode',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Sender.BirthPlace.Region',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Region',
      ShortName: 'Région',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Région.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Region',
      ApiField: 'Region',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Sender.BirthPlace.Region',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Sender.Corpname',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Corpname',
      ShortName: "Nom de l'entité",
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Corpname',
      ApiField: 'Corpname',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Sender.Corpname',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Sender.DeathDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'DeathDate',
      ShortName: 'date de décès',
      Description: "Mapping : unit-es-mapping.json. Date de décès d'une personne.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'DeathDate',
      ApiField: 'DeathDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Sender.DeathDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: 'Sender.DeathPlace',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'DeathPlace',
      ShortName: 'Lieu de décès',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'DeathPlace',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Sender.DeathPlace',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'Sender.DeathPlace.Address',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Address',
      ShortName: 'Adresse',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Adresse. Références : ead.address",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Address',
      ApiField: 'Address',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Sender.DeathPlace.Address',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Sender.DeathPlace.City',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'City',
      ShortName: 'Ville',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Ville.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'City',
      ApiField: 'City',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Sender.DeathPlace.City',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Sender.DeathPlace.Country',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Country',
      ShortName: 'Pays',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Pays.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Country',
      ApiField: 'Country',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Sender.DeathPlace.Country',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Sender.DeathPlace.Geogname',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Geogname',
      ShortName: 'Nom de lieu',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Nom géographique. Références : ead.geogname",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Geogname',
      ApiField: 'Geogname',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Sender.DeathPlace.Geogname',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Sender.DeathPlace.PostalCode',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'PostalCode',
      ShortName: 'Code postal',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Code postal.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'PostalCode',
      ApiField: 'PostalCode',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Sender.DeathPlace.PostalCode',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Sender.DeathPlace.Region',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Region',
      ShortName: 'Région',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Région.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Region',
      ApiField: 'Region',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Sender.DeathPlace.Region',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Sender.FirstName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'FirstName',
      ShortName: 'Prénom',
      Description: "Mapping : unit-es-mapping.json. Prénom d'une personne.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'FirstName',
      ApiField: 'FirstName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Sender.FirstName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Sender.FullName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'FullName',
      ShortName: 'Nom complet',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'FullName',
      ApiField: 'FullName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Sender.FullName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Sender.Function',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Function',
      ShortName: 'Fonction',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Fonction.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Function',
      ApiField: 'Function',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Sender.Function',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Sender.Gender',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Gender',
      ShortName: 'Sexe',
      Description: 'Mapping : unit-es-mapping.json. Sexe de la personne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Gender',
      ApiField: 'Gender',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Sender.Gender',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Sender.GivenName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'GivenName',
      ShortName: "Nom d'usage",
      Description: "Mapping : unit-es-mapping.json. Nom d'usage d'une personne.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'GivenName',
      ApiField: 'GivenName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Sender.GivenName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Sender.Identifier',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Identifier',
      ShortName: 'Identifiant',
      Description:
        "Mapping : unit-es-mapping.json. UNITE ARCHIVISTIQUE : Dans le PersonGroup, Identifiant de type numéro matricule. Dans le EntityGroup, Identifiant de l'entité. REFERENTIELS : identifiant.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Identifier',
      ApiField: 'Identifier',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Sender.Identifier',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Sender.Mandate',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Mandate',
      ShortName: 'Droits',
      Description: 'Mapping : unit-es-mapping.json. Mandat octroyé à la personne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Mandate',
      ApiField: 'Mandate',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Sender.Mandate',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Sender.Nationality',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Nationality',
      ShortName: 'nationalité',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Nationality',
      ApiField: 'Nationality',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Sender.Nationality',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Sender.Position',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Position',
      ShortName: 'Position',
      Description: 'Mapping : unit-es-mapping.json. Intitulé du poste de travail occupé par la personne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Position',
      ApiField: 'Position',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Sender.Position',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Sender.Role',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Role',
      ShortName: 'Rôle',
      Description:
        'Mapping : unit-es-mapping.json. Droits avec lesquels un utilisateur a réalisé une opération, notamment dans une application.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Role',
      ApiField: 'Role',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Sender.Role',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SentDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'SentDate',
      ShortName: "Date d'envoi",
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'SentDate',
      ApiField: 'SentDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SentDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: 'Signature',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'Signature',
      ShortName: 'Signature',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Signature',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'Signature.Masterdata',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'Masterdata',
      ShortName: 'Référentiel des personnes et des organisations',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Masterdata',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Masterdata',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'Signature.ReferencedObject',
      StringSize: null,
      Cardinality: 'ONE_REQUIRED',
      FieldName: 'ReferencedObject',
      ShortName: "Référence à l'objet signé",
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'ReferencedObject',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.ReferencedObject',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'Signature.ReferencedObject.SignedObjectDigest',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'SignedObjectDigest',
      ShortName: "Empreinte de l'objet signé",
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'SignedObjectDigest',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.ReferencedObject.SignedObjectDigest',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'Signature.ReferencedObject.SignedObjectDigest.Algorithm',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'Algorithm',
      ShortName: 'Algorithme',
      Description: 'Mapping : unit-es-mapping.json. Attribut SEDA.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Algorithm',
      ApiField: 'Algorithm',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.ReferencedObject.SignedObjectDigest.Algorithm',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.ReferencedObject.SignedObjectDigest.MessageDigest',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'MessageDigest',
      ShortName: 'Empreinte',
      Description: 'Mapping : og-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'MessageDigest',
      ApiField: 'MessageDigest',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.ReferencedObject.SignedObjectDigest.MessageDigest',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.ReferencedObject.SignedObjectId',
      StringSize: 'SHORT',
      Cardinality: 'ONE_REQUIRED',
      FieldName: 'SignedObjectId',
      ShortName: "Identifiant de l'objet de données signé",
      Description: "Mapping : unit-es-mapping.json. Identifiant de l'objet-données signé.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'SignedObjectId',
      ApiField: 'SignedObjectId',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.ReferencedObject.SignedObjectId',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Signer',
      StringSize: null,
      Cardinality: 'MANY_REQUIRED',
      FieldName: 'Signer',
      ShortName: 'Signataire',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Signer',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Signer',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'Signature.Signer.Activity',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Activity',
      ShortName: 'Activité',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Activité.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Activity',
      ApiField: 'Activity',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Signer.Activity',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Signer.BirthDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'BirthDate',
      ShortName: 'Date de naissance',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'BirthDate',
      ApiField: 'BirthDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Signer.BirthDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: 'Signature.Signer.BirthName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'BirthName',
      ShortName: 'Nom de naissance',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'BirthName',
      ApiField: 'BirthName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Signer.BirthName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Signer.BirthPlace',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'BirthPlace',
      ShortName: 'Lieu de naissance',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'BirthPlace',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Signer.BirthPlace',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'Signature.Signer.BirthPlace.Address',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Address',
      ShortName: 'Adresse',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Adresse. Références : ead.address",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Address',
      ApiField: 'Address',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Signer.BirthPlace.Address',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Signer.BirthPlace.City',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'City',
      ShortName: 'Ville',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Ville.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'City',
      ApiField: 'City',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Signer.BirthPlace.City',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Signer.BirthPlace.Country',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Country',
      ShortName: 'Pays',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Pays.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Country',
      ApiField: 'Country',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Signer.BirthPlace.Country',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Signer.BirthPlace.Geogname',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Geogname',
      ShortName: 'Nom de lieu',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Nom géographique. Références : ead.geogname",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Geogname',
      ApiField: 'Geogname',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Signer.BirthPlace.Geogname',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Signer.BirthPlace.PostalCode',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'PostalCode',
      ShortName: 'Code postal',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Code postal.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'PostalCode',
      ApiField: 'PostalCode',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Signer.BirthPlace.PostalCode',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Signer.BirthPlace.Region',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Region',
      ShortName: 'Région',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Région.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Region',
      ApiField: 'Region',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Signer.BirthPlace.Region',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Signer.Corpname',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Corpname',
      ShortName: "Nom de l'entité",
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Corpname',
      ApiField: 'Corpname',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Signer.Corpname',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Signer.DeathDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'DeathDate',
      ShortName: 'Date de décès',
      Description: "Mapping : unit-es-mapping.json. Date de décès d'une personne.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'DeathDate',
      ApiField: 'DeathDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Signer.DeathDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: 'Signature.Signer.DeathPlace',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'DeathPlace',
      ShortName: 'Lieu de décès',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'DeathPlace',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Signer.DeathPlace',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'Signature.Signer.DeathPlace.Address',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Address',
      ShortName: 'Adresse',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Adresse. Références : ead.address",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Address',
      ApiField: 'Address',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Signer.DeathPlace.Address',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Signer.DeathPlace.City',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'City',
      ShortName: 'Ville',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Ville.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'City',
      ApiField: 'City',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Signer.DeathPlace.City',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Signer.DeathPlace.Country',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Country',
      ShortName: 'Pays',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Pays.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Country',
      ApiField: 'Country',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Signer.DeathPlace.Country',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Signer.DeathPlace.Geogname',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Geogname',
      ShortName: 'Nom de lieu',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Nom géographique. Références : ead.geogname",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Geogname',
      ApiField: 'Geogname',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Signer.DeathPlace.Geogname',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Signer.DeathPlace.PostalCode',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'PostalCode',
      ShortName: 'Code postal',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Code postal.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'PostalCode',
      ApiField: 'PostalCode',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Signer.DeathPlace.PostalCode',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Signer.DeathPlace.Region',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Region',
      ShortName: 'Région',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Région.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Region',
      ApiField: 'Region',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Signer.DeathPlace.Region',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Signer.FirstName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'FirstName',
      ShortName: 'Prénom',
      Description: "Mapping : unit-es-mapping.json. Prénom d'une personne.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'FirstName',
      ApiField: 'FirstName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Signer.FirstName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Signer.FullName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'FullName',
      ShortName: 'Nom complet',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'FullName',
      ApiField: 'FullName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Signer.FullName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Signer.Function',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Function',
      ShortName: 'Fonction',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Fonction.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Function',
      ApiField: 'Function',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Signer.Function',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Signer.Gender',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Gender',
      ShortName: 'Sexe',
      Description: 'Mapping : unit-es-mapping.json. Sexe de la personne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Gender',
      ApiField: 'Gender',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Signer.Gender',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Signer.GivenName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'GivenName',
      ShortName: "Nom d'usage",
      Description: "Mapping : unit-es-mapping.json. Nom d'usage d'une personne.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'GivenName',
      ApiField: 'GivenName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Signer.GivenName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Signer.Identifier',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Identifier',
      ShortName: 'Identifiant',
      Description:
        "Mapping : unit-es-mapping.json. UNITE ARCHIVISTIQUE : Dans le PersonGroup, Identifiant de type numéro matricule. Dans le EntityGroup, Identifiant de l'entité. REFERENTIELS : identifiant.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Identifier',
      ApiField: 'Identifier',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Signer.Identifier',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Signer.Mandate',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Mandate',
      ShortName: 'Droits',
      Description: 'Mapping : unit-es-mapping.json. Mandat octroyé à la personne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Mandate',
      ApiField: 'Mandate',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Signer.Mandate',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Signer.Nationality',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Nationality',
      ShortName: 'nationalité',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Nationality',
      ApiField: 'Nationality',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Signer.Nationality',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Signer.Position',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Position',
      ShortName: 'Position',
      Description: 'Mapping : unit-es-mapping.json. Intitulé du poste de travail occupé par la personne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Position',
      ApiField: 'Position',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Signer.Position',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Signer.Role',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Role',
      ShortName: 'Rôle',
      Description:
        'Mapping : unit-es-mapping.json. Droits avec lesquels un utilisateur a réalisé une opération, notamment dans une application.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Role',
      ApiField: 'Role',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Signer.Role',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Signer.SigningTime',
      StringSize: null,
      Cardinality: 'ONE_REQUIRED',
      FieldName: 'SigningTime',
      ShortName: 'Date de signature',
      Description: 'Mapping : unit-es-mapping.json. Date de signature',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'SigningTime',
      ApiField: 'SigningTime',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Signer.SigningTime',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: 'Signature.Validator',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'Validator',
      ShortName: 'Validateur',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Validator',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Validator',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'Signature.Validator.Activity',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Activity',
      ShortName: 'Activité',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Activité.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Activity',
      ApiField: 'Activity',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Validator.Activity',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Validator.BirthDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'BirthDate',
      ShortName: 'Date de naissance',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'BirthDate',
      ApiField: 'BirthDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Validator.BirthDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: 'Signature.Validator.BirthName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'BirthName',
      ShortName: 'Nom de naissance',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'BirthName',
      ApiField: 'BirthName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Validator.BirthName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Validator.BirthPlace',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'BirthPlace',
      ShortName: 'Lieu de naissance',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'BirthPlace',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Validator.BirthPlace',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'Signature.Validator.BirthPlace.Address',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Address',
      ShortName: 'Adresse',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Adresse. Références : ead.address",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Address',
      ApiField: 'Address',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Validator.BirthPlace.Address',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Validator.BirthPlace.City',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'City',
      ShortName: 'Ville',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Ville.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'City',
      ApiField: 'City',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Validator.BirthPlace.City',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Validator.BirthPlace.Country',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Country',
      ShortName: 'Pays',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Pays.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Country',
      ApiField: 'Country',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Validator.BirthPlace.Country',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Validator.BirthPlace.Geogname',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Geogname',
      ShortName: 'Nom de lieu',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Nom géographique. Références : ead.geogname",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Geogname',
      ApiField: 'Geogname',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Validator.BirthPlace.Geogname',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Validator.BirthPlace.PostalCode',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'PostalCode',
      ShortName: 'Code postal',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Code postal.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'PostalCode',
      ApiField: 'PostalCode',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Validator.BirthPlace.PostalCode',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Validator.BirthPlace.Region',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Region',
      ShortName: 'Région',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Région.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Region',
      ApiField: 'Region',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Validator.BirthPlace.Region',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Validator.Corpname',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Corpname',
      ShortName: "Nom de l'entité",
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Corpname',
      ApiField: 'Corpname',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Validator.Corpname',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Validator.DeathDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'DeathDate',
      ShortName: 'date de décès',
      Description: "Mapping : unit-es-mapping.json. Date de décès d'une personne.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'DeathDate',
      ApiField: 'DeathDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Validator.DeathDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: 'Signature.Validator.DeathPlace',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'DeathPlace',
      ShortName: 'Lieu de décès',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'DeathPlace',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Validator.DeathPlace',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'Signature.Validator.DeathPlace.Address',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Address',
      ShortName: 'Adresse',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Adresse. Références : ead.address",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Address',
      ApiField: 'Address',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Validator.DeathPlace.Address',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Validator.DeathPlace.City',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'City',
      ShortName: 'Ville',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Ville.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'City',
      ApiField: 'City',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Validator.DeathPlace.City',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Validator.DeathPlace.Country',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Country',
      ShortName: 'Pays',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Pays.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Country',
      ApiField: 'Country',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Validator.DeathPlace.Country',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Validator.DeathPlace.Geogname',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Geogname',
      ShortName: 'Nom de lieu',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Nom géographique. Références : ead.geogname",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Geogname',
      ApiField: 'Geogname',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Validator.DeathPlace.Geogname',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Validator.DeathPlace.PostalCode',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'PostalCode',
      ShortName: 'Code postal',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Code postal.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'PostalCode',
      ApiField: 'PostalCode',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Validator.DeathPlace.PostalCode',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Validator.DeathPlace.Region',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Region',
      ShortName: 'Région',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Région.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Region',
      ApiField: 'Region',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Validator.DeathPlace.Region',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Validator.FirstName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'FirstName',
      ShortName: 'Prénom',
      Description: "Mapping : unit-es-mapping.json. Prénom d'une personne.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'FirstName',
      ApiField: 'FirstName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Validator.FirstName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Validator.FullName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'FullName',
      ShortName: 'Nom complet',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'FullName',
      ApiField: 'FullName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Validator.FullName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Validator.Function',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Function',
      ShortName: 'Fonction',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Fonction.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Function',
      ApiField: 'Function',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Validator.Function',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Validator.Gender',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Gender',
      ShortName: 'Sexe',
      Description: 'Mapping : unit-es-mapping.json. Sexe de la personne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Gender',
      ApiField: 'Gender',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Validator.Gender',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Validator.GivenName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'GivenName',
      ShortName: "Nom d'usage",
      Description: "Mapping : unit-es-mapping.json. Nom d'usage d'une personne.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'GivenName',
      ApiField: 'GivenName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Validator.GivenName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Validator.Identifier',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Identifier',
      ShortName: 'Identifiant',
      Description:
        "Mapping : unit-es-mapping.json. UNITE ARCHIVISTIQUE : Dans le PersonGroup, Identifiant de type numéro matricule. Dans le EntityGroup, Identifiant de l'entité. REFERENTIELS : identifiant.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Identifier',
      ApiField: 'Identifier',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Validator.Identifier',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Validator.Mandate',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Mandate',
      ShortName: 'Droits',
      Description: 'Mapping : unit-es-mapping.json. Mandat octroyé à la personne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Mandate',
      ApiField: 'Mandate',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Validator.Mandate',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Validator.Nationality',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Nationality',
      ShortName: 'nationalité',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Nationality',
      ApiField: 'Nationality',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Validator.Nationality',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Validator.Position',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Position',
      ShortName: 'Position',
      Description: 'Mapping : unit-es-mapping.json. Intitulé du poste de travail occupé par la personne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Position',
      ApiField: 'Position',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Validator.Position',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Validator.Role',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Role',
      ShortName: 'Rôle',
      Description:
        'Mapping : unit-es-mapping.json. Droits avec lesquels un utilisateur a réalisé une opération, notamment dans une application.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Role',
      ApiField: 'Role',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Validator.Role',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Signature.Validator.ValidationTime',
      StringSize: null,
      Cardinality: 'ONE_REQUIRED',
      FieldName: 'ValidationTime',
      ShortName: 'Date de validation',
      Description: 'Mapping : unit-es-mapping.json. Date de la validation de la signature.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'ValidationTime',
      ApiField: 'ValidationTime',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2'],
      Category: 'DESCRIPTION',
      ApiPath: 'Signature.Validator.ValidationTime',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: 'SigningInformation',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'SigningInformation',
      ShortName: 'Informations sur la signature',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'SigningInformation',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'SigningInformation.AdditionalProof',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'AdditionalProof',
      ShortName: 'Preuve complémentaire',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'AdditionalProof',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.AdditionalProof',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'SigningInformation.AdditionalProof.AdditionalProofInformation',
      StringSize: 'LARGE',
      Cardinality: 'ONE',
      FieldName: 'AdditionalProofInformation',
      ShortName: 'Description',
      Description:
        'Mapping : unit-es-mapping.json. Informations relatives aux preuves complémentaires archivées dans un contexte de signature.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'AdditionalProofInformation',
      ApiField: 'AdditionalProofInformation',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.AdditionalProof.AdditionalProofInformation',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.DetachedSigningRole',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'DetachedSigningRole',
      ShortName: "Rôle de l'unité encapsulée",
      Description:
        "Mapping : unit-es-mapping.json. Référence aux rôles des unités d'archives encapsulées sous la racine contenant le document signé.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'DetachedSigningRole',
      ApiField: 'DetachedSigningRole',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.DetachedSigningRole',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.Extended',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'Extended',
      ShortName: 'Extended',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Extended',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.Extended',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'SignatureDescription',
      ShortName: 'Signature',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'SignatureDescription',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Signer',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'Signer',
      ShortName: 'Signataire',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Signer',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Signer',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Signer.Activity',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Activity',
      ShortName: 'Activité',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Activité.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Activity',
      ApiField: 'Activity',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Signer.Activity',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Signer.BirthDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'BirthDate',
      ShortName: 'Date de naissance',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'BirthDate',
      ApiField: 'BirthDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Signer.BirthDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Signer.BirthName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'BirthName',
      ShortName: 'Nom de naissance',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'BirthName',
      ApiField: 'BirthName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Signer.BirthName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Signer.BirthPlace',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'BirthPlace',
      ShortName: 'Lieu de naissance',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'BirthPlace',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Signer.BirthPlace',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Signer.BirthPlace.Address',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Address',
      ShortName: 'Adresse',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Adresse. Références : ead.address",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Address',
      ApiField: 'Address',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Signer.BirthPlace.Address',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Signer.BirthPlace.City',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'City',
      ShortName: 'Ville',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Ville.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'City',
      ApiField: 'City',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Signer.BirthPlace.City',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Signer.BirthPlace.Country',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Country',
      ShortName: 'Pays',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Pays.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Country',
      ApiField: 'Country',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Signer.BirthPlace.Country',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Signer.BirthPlace.Geogname',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Geogname',
      ShortName: 'Nom de lieu',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Nom géographique. Références : ead.geogname",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Geogname',
      ApiField: 'Geogname',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Signer.BirthPlace.Geogname',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Signer.BirthPlace.PostalCode',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'PostalCode',
      ShortName: 'Code postal',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Code postal.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'PostalCode',
      ApiField: 'PostalCode',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Signer.BirthPlace.PostalCode',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Signer.BirthPlace.Region',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Region',
      ShortName: 'Région',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Région.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Region',
      ApiField: 'Region',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Signer.BirthPlace.Region',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Signer.Corpname',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Corpname',
      ShortName: "Nom de l'entité",
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Corpname',
      ApiField: 'Corpname',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Signer.Corpname',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Signer.DeathDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'DeathDate',
      ShortName: 'Date de décès',
      Description: "Mapping : unit-es-mapping.json. Date de décès d'une personne.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'DeathDate',
      ApiField: 'DeathDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Signer.DeathDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Signer.DeathPlace',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'DeathPlace',
      ShortName: 'Lieu de décès',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'DeathPlace',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Signer.DeathPlace',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Signer.DeathPlace.Address',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Address',
      ShortName: 'Adresse',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Adresse. Références : ead.address",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Address',
      ApiField: 'Address',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Signer.DeathPlace.Address',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Signer.DeathPlace.City',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'City',
      ShortName: 'Ville',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Ville.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'City',
      ApiField: 'City',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Signer.DeathPlace.City',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Signer.DeathPlace.Country',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Country',
      ShortName: 'Pays',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Pays.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Country',
      ApiField: 'Country',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Signer.DeathPlace.Country',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Signer.DeathPlace.Geogname',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Geogname',
      ShortName: 'Nom de lieu',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Nom géographique. Références : ead.geogname",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Geogname',
      ApiField: 'Geogname',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Signer.DeathPlace.Geogname',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Signer.DeathPlace.PostalCode',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'PostalCode',
      ShortName: 'Code postal',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Code postal.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'PostalCode',
      ApiField: 'PostalCode',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Signer.DeathPlace.PostalCode',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Signer.DeathPlace.Region',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Region',
      ShortName: 'Région',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Région.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Region',
      ApiField: 'Region',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Signer.DeathPlace.Region',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Signer.FirstName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'FirstName',
      ShortName: 'Prénom',
      Description: "Mapping : unit-es-mapping.json. Prénom d'une personne.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'FirstName',
      ApiField: 'FirstName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Signer.FirstName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Signer.FullName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'FullName',
      ShortName: 'Nom / Nom + Prénom',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'FullName',
      ApiField: 'FullName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Signer.FullName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Signer.Function',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Function',
      ShortName: 'Fonction',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Fonction.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Function',
      ApiField: 'Function',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Signer.Function',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Signer.Gender',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Gender',
      ShortName: 'Sexe',
      Description: 'Mapping : unit-es-mapping.json. Sexe de la personne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Gender',
      ApiField: 'Gender',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Signer.Gender',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Signer.GivenName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'GivenName',
      ShortName: "Nom d'usage",
      Description: "Mapping : unit-es-mapping.json. Nom d'usage d'une personne.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'GivenName',
      ApiField: 'GivenName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Signer.GivenName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Signer.Identifier',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Identifier',
      ShortName: 'Identifiant',
      Description:
        "Mapping : unit-es-mapping.json. UNITE ARCHIVISTIQUE : Dans le PersonGroup, Identifiant de type numéro matricule. Dans le EntityGroup, Identifiant de l'entité. REFERENTIELS : identifiant.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Identifier',
      ApiField: 'Identifier',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Signer.Identifier',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Signer.Mandate',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Mandate',
      ShortName: 'Droits',
      Description: 'Mapping : unit-es-mapping.json. Mandat octroyé à la personne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Mandate',
      ApiField: 'Mandate',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Signer.Mandate',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Signer.Nationality',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Nationality',
      ShortName: 'nationalité',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Nationality',
      ApiField: 'Nationality',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Signer.Nationality',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Signer.Position',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Position',
      ShortName: 'Position',
      Description: 'Mapping : unit-es-mapping.json. Intitulé du poste de travail occupé par la personne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Position',
      ApiField: 'Position',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Signer.Position',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Signer.Role',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Role',
      ShortName: 'Rôle',
      Description:
        'Mapping : unit-es-mapping.json. Droits avec lesquels un utilisateur a réalisé une opération, notamment dans une application.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Role',
      ApiField: 'Role',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Signer.Role',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Signer.SigningTime',
      StringSize: null,
      Cardinality: 'ONE_REQUIRED',
      FieldName: 'SigningTime',
      ShortName: 'Date de signature',
      Description: 'Mapping : unit-es-mapping.json. Date de signature',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'SigningTime',
      ApiField: 'SigningTime',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Signer.SigningTime',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.SigningType',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'SigningType',
      ShortName: 'Type de signature',
      Description:
        'Mapping : unit-es-mapping.json. Type de signature, au sens juridique du terme. Par exemple, simple, avancée, qualifiée.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'SigningType',
      ApiField: 'SigningType',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.SigningType',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Validator',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'Validator',
      ShortName: 'Validateur',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Validator',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Validator',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Validator.Activity',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Activity',
      ShortName: 'Activité',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Activité.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Activity',
      ApiField: 'Activity',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Validator.Activity',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Validator.BirthDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'BirthDate',
      ShortName: 'Date de naissance',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'BirthDate',
      ApiField: 'BirthDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Validator.BirthDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Validator.BirthName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'BirthName',
      ShortName: 'Nom de naissance',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'BirthName',
      ApiField: 'BirthName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Validator.BirthName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Validator.BirthPlace',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'BirthPlace',
      ShortName: 'Lieu de naissance',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'BirthPlace',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Validator.BirthPlace',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Validator.BirthPlace.Address',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Address',
      ShortName: 'Adresse',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Adresse. Références : ead.address",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Address',
      ApiField: 'Address',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Validator.BirthPlace.Address',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Validator.BirthPlace.City',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'City',
      ShortName: 'Ville',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Ville.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'City',
      ApiField: 'City',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Validator.BirthPlace.City',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Validator.BirthPlace.Country',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Country',
      ShortName: 'Pays',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Pays.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Country',
      ApiField: 'Country',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Validator.BirthPlace.Country',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Validator.BirthPlace.Geogname',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Geogname',
      ShortName: 'Nom de lieu',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Nom géographique. Références : ead.geogname",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Geogname',
      ApiField: 'Geogname',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Validator.BirthPlace.Geogname',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Validator.BirthPlace.PostalCode',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'PostalCode',
      ShortName: 'Code postal',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Code postal.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'PostalCode',
      ApiField: 'PostalCode',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Validator.BirthPlace.PostalCode',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Validator.BirthPlace.Region',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Region',
      ShortName: 'Région',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Région.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Region',
      ApiField: 'Region',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Validator.BirthPlace.Region',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Validator.Corpname',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Corpname',
      ShortName: "Nom de l'entité",
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Corpname',
      ApiField: 'Corpname',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Validator.Corpname',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Validator.DeathDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'DeathDate',
      ShortName: 'date de décès',
      Description: "Mapping : unit-es-mapping.json. Date de décès d'une personne.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'DeathDate',
      ApiField: 'DeathDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Validator.DeathDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Validator.DeathPlace',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'DeathPlace',
      ShortName: 'Lieu de décès',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'DeathPlace',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Validator.DeathPlace',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Validator.DeathPlace.Address',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Address',
      ShortName: 'Adresse',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Adresse. Références : ead.address",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Address',
      ApiField: 'Address',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Validator.DeathPlace.Address',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Validator.DeathPlace.City',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'City',
      ShortName: 'Ville',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Ville.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'City',
      ApiField: 'City',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Validator.DeathPlace.City',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Validator.DeathPlace.Country',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Country',
      ShortName: 'Pays',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Pays.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Country',
      ApiField: 'Country',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Validator.DeathPlace.Country',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Validator.DeathPlace.Geogname',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Geogname',
      ShortName: 'Nom de lieu',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Nom géographique. Références : ead.geogname",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Geogname',
      ApiField: 'Geogname',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Validator.DeathPlace.Geogname',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Validator.DeathPlace.PostalCode',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'PostalCode',
      ShortName: 'Code postal',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Code postal.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'PostalCode',
      ApiField: 'PostalCode',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Validator.DeathPlace.PostalCode',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Validator.DeathPlace.Region',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Region',
      ShortName: 'Région',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Région.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Region',
      ApiField: 'Region',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Validator.DeathPlace.Region',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Validator.FirstName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'FirstName',
      ShortName: 'Prénom',
      Description: "Mapping : unit-es-mapping.json. Prénom d'une personne.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'FirstName',
      ApiField: 'FirstName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Validator.FirstName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Validator.FullName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'FullName',
      ShortName: 'Nom / Nom + Prénom',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'FullName',
      ApiField: 'FullName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Validator.FullName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Validator.Function',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Function',
      ShortName: 'Fonction',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Fonction.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Function',
      ApiField: 'Function',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Validator.Function',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Validator.Gender',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Gender',
      ShortName: 'Sexe',
      Description: 'Mapping : unit-es-mapping.json. Sexe de la personne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Gender',
      ApiField: 'Gender',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Validator.Gender',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Validator.GivenName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'GivenName',
      ShortName: "Nom d'usage",
      Description: "Mapping : unit-es-mapping.json. Nom d'usage d'une personne.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'GivenName',
      ApiField: 'GivenName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Validator.GivenName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Validator.Identifier',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Identifier',
      ShortName: 'Identifiant',
      Description:
        "Mapping : unit-es-mapping.json. UNITE ARCHIVISTIQUE : Dans le PersonGroup, Identifiant de type numéro matricule. Dans le EntityGroup, Identifiant de l'entité. REFERENTIELS : identifiant.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Identifier',
      ApiField: 'Identifier',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Validator.Identifier',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Validator.Mandate',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Mandate',
      ShortName: 'Droits',
      Description: 'Mapping : unit-es-mapping.json. Mandat octroyé à la personne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Mandate',
      ApiField: 'Mandate',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Validator.Mandate',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Validator.Nationality',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Nationality',
      ShortName: 'nationalité',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Nationality',
      ApiField: 'Nationality',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Validator.Nationality',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Validator.Position',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Position',
      ShortName: 'Position',
      Description: 'Mapping : unit-es-mapping.json. Intitulé du poste de travail occupé par la personne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Position',
      ApiField: 'Position',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Validator.Position',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Validator.Role',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Role',
      ShortName: 'Rôle',
      Description:
        'Mapping : unit-es-mapping.json. Droits avec lesquels un utilisateur a réalisé une opération, notamment dans une application.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Role',
      ApiField: 'Role',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Validator.Role',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.SignatureDescription.Validator.ValidationTime',
      StringSize: null,
      Cardinality: 'ONE_REQUIRED',
      FieldName: 'ValidationTime',
      ShortName: 'Date de validation',
      Description: 'Mapping : unit-es-mapping.json. Date de la validation de la signature.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'ValidationTime',
      ApiField: 'ValidationTime',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SignatureDescription.Validator.ValidationTime',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: 'SigningInformation.SigningRole',
      StringSize: null,
      Cardinality: 'MANY_REQUIRED',
      FieldName: 'SigningRole',
      ShortName: 'Rôle',
      Description:
        "Mapping : unit-es-mapping.json. Rôle de l'unité d'archives dans un contexte de signature. Quatre rôles (étiquettes) ont été identifiés : document signé, signature, horodatage et preuves complémentaires.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'SigningRole',
      ApiField: 'SigningRole',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.SigningRole',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.TimestampingInformation',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'TimestampingInformation',
      ShortName: "Information d'horodatage",
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'TimestampingInformation',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.TimestampingInformation',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'SigningInformation.TimestampingInformation.AdditionalTimestampingInformation',
      StringSize: 'LARGE',
      Cardinality: 'ONE',
      FieldName: 'AdditionalTimestampingInformation',
      ShortName: "Description de l'horodatage",
      Description: "Mapping : unit-es-mapping.json. Informations complémentaires sur l'horodatage d'une signature",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'AdditionalTimestampingInformation',
      ApiField: 'AdditionalTimestampingInformation',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.TimestampingInformation.AdditionalTimestampingInformation',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SigningInformation.TimestampingInformation.TimeStamp',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'TimeStamp',
      ShortName: 'Horodatage de la signature',
      Description: 'Mapping : unit-es-mapping.json. Horodatage de la signature',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'TimeStamp',
      ApiField: 'TimeStamp',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SigningInformation.TimestampingInformation.TimeStamp',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: 'Source',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Source',
      ShortName: 'Source',
      Description: 'Mapping : unit-es-mapping.json. En cas de substitution numérique, permet de faire référence au papier.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Source',
      ApiField: 'Source',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Source',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'StartDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'StartDate',
      ShortName: 'Date de début',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'StartDate',
      ApiField: 'StartDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'StartDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: 'Status',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Status',
      ShortName: 'Statut',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Status',
      ApiField: 'Status',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Status',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SubmissionAgency',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'SubmissionAgency',
      ShortName: 'Service versant',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'SubmissionAgencyIdentifier',
      ApiField: 'SubmissionAgency',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SubmissionAgency',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'SubmissionAgency.Identifier',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Identifier',
      ShortName: 'Identifiant du service versant',
      Description:
        "Mapping : unit-es-mapping.json. UNITE ARCHIVISTIQUE : Dans le PersonGroup, Identifiant de type numéro matricule. Dans le EntityGroup, Identifiant de l'entité. REFERENTIELS : identifiant.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Identifier',
      ApiField: 'Identifier',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SubmissionAgency.Identifier',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'SubmissionAgency.OrganizationDescriptiveMetadata',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'OrganizationDescriptiveMetadata',
      ShortName: 'OrganizationDescriptiveMetadata',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'OrganizationDescriptiveMetadata',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SubmissionAgency.OrganizationDescriptiveMetadata',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'SystemId',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'SystemId',
      ShortName: 'Identifiant technique du système',
      Description:
        'Mapping : unit-es-mapping.json. Identifiant attribué aux objets. Il est attribué par le SAE et correspond à un identifiant interne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'SystemId',
      ApiField: 'SystemId',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'SystemId',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Tag',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Tag',
      ShortName: 'Tag',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Tag',
      ApiField: 'Tag',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Tag',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'TextContent',
      StringSize: 'MEDIUM',
      Cardinality: 'MANY',
      FieldName: 'TextContent',
      ShortName: 'Contenu',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'TextContent',
      ApiField: 'TextContent',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'TextContent',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Title',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'Title',
      ShortName: 'Intitulé',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Title',
      ApiField: 'Title',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Title',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Title_',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'Title_',
      ShortName: 'Intitulé',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Title_',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Title_',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'TransactedDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'TransactedDate',
      ShortName: 'Date de transaction',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'TransactedDate',
      ApiField: 'TransactedDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'TransactedDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: 'TransferringAgencyArchiveUnitIdentifier',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'TransferringAgencyArchiveUnitIdentifier',
      ShortName: 'Identifiant attribué par le service versant',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'TransferringAgencyArchiveUnitIdentifier',
      ApiField: 'TransferringAgencyArchiveUnitIdentifier',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'TransferringAgencyArchiveUnitIdentifier',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Transmitter',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'Transmitter',
      ShortName: 'Emetteur',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Transmitter',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Transmitter',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'Transmitter.Activity',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Activity',
      ShortName: 'Activité',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Activité.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Activity',
      ApiField: 'Activity',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Transmitter.Activity',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Transmitter.BirthDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'BirthDate',
      ShortName: 'Date de naissance',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'BirthDate',
      ApiField: 'BirthDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Transmitter.BirthDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: 'Transmitter.BirthName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'BirthName',
      ShortName: 'Nom de naissance',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'BirthName',
      ApiField: 'BirthName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Transmitter.BirthName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Transmitter.BirthPlace',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'BirthPlace',
      ShortName: 'Lieu de naissance',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'BirthPlace',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Transmitter.BirthPlace',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'Transmitter.BirthPlace.Address',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Address',
      ShortName: 'Adresse',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Adresse. Références : ead.address",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Address',
      ApiField: 'Address',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Transmitter.BirthPlace.Address',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Transmitter.BirthPlace.City',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'City',
      ShortName: 'Ville',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Ville.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'City',
      ApiField: 'City',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Transmitter.BirthPlace.City',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Transmitter.BirthPlace.Country',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Country',
      ShortName: 'Pays',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Pays.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Country',
      ApiField: 'Country',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Transmitter.BirthPlace.Country',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Transmitter.BirthPlace.Geogname',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Geogname',
      ShortName: 'Nom de lieu',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Nom géographique. Références : ead.geogname",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Geogname',
      ApiField: 'Geogname',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Transmitter.BirthPlace.Geogname',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Transmitter.BirthPlace.PostalCode',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'PostalCode',
      ShortName: 'Code postal',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Code postal.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'PostalCode',
      ApiField: 'PostalCode',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Transmitter.BirthPlace.PostalCode',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Transmitter.BirthPlace.Region',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Region',
      ShortName: 'Région',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Région.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Region',
      ApiField: 'Region',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Transmitter.BirthPlace.Region',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Transmitter.Corpname',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Corpname',
      ShortName: "Nom de l'entité",
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Corpname',
      ApiField: 'Corpname',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Transmitter.Corpname',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Transmitter.DeathDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'DeathDate',
      ShortName: 'date de décès',
      Description: "Mapping : unit-es-mapping.json. Date de décès d'une personne.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'DeathDate',
      ApiField: 'DeathDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Transmitter.DeathDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: 'Transmitter.DeathPlace',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'DeathPlace',
      ShortName: 'Lieu de décès',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'DeathPlace',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Transmitter.DeathPlace',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'Transmitter.DeathPlace.Address',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Address',
      ShortName: 'Adresse',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Adresse. Références : ead.address",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Address',
      ApiField: 'Address',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Transmitter.DeathPlace.Address',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Transmitter.DeathPlace.City',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'City',
      ShortName: 'Ville',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Ville.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'City',
      ApiField: 'City',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Transmitter.DeathPlace.City',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Transmitter.DeathPlace.Country',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Country',
      ShortName: 'Pays',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Pays.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Country',
      ApiField: 'Country',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Transmitter.DeathPlace.Country',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Transmitter.DeathPlace.Geogname',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Geogname',
      ShortName: 'Nom de lieu',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Nom géographique. Références : ead.geogname",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Geogname',
      ApiField: 'Geogname',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Transmitter.DeathPlace.Geogname',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Transmitter.DeathPlace.PostalCode',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'PostalCode',
      ShortName: 'Code postal',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Code postal.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'PostalCode',
      ApiField: 'PostalCode',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Transmitter.DeathPlace.PostalCode',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Transmitter.DeathPlace.Region',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Region',
      ShortName: 'Région',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Région.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Region',
      ApiField: 'Region',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Transmitter.DeathPlace.Region',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Transmitter.FirstName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'FirstName',
      ShortName: 'Prénom',
      Description: "Mapping : unit-es-mapping.json. Prénom d'une personne.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'FirstName',
      ApiField: 'FirstName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Transmitter.FirstName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Transmitter.FullName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'FullName',
      ShortName: 'Nom complet',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'FullName',
      ApiField: 'FullName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Transmitter.FullName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Transmitter.Function',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Function',
      ShortName: 'Fonction',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Fonction.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Function',
      ApiField: 'Function',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Transmitter.Function',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Transmitter.Gender',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Gender',
      ShortName: 'Sexe',
      Description: 'Mapping : unit-es-mapping.json. Sexe de la personne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Gender',
      ApiField: 'Gender',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Transmitter.Gender',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Transmitter.GivenName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'GivenName',
      ShortName: "Nom d'usage",
      Description: "Mapping : unit-es-mapping.json. Nom d'usage d'une personne.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'GivenName',
      ApiField: 'GivenName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Transmitter.GivenName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Transmitter.Identifier',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Identifier',
      ShortName: 'Identifiant',
      Description:
        "Mapping : unit-es-mapping.json. UNITE ARCHIVISTIQUE : Dans le PersonGroup, Identifiant de type numéro matricule. Dans le EntityGroup, Identifiant de l'entité. REFERENTIELS : identifiant.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Identifier',
      ApiField: 'Identifier',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Transmitter.Identifier',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Transmitter.Mandate',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Mandate',
      ShortName: 'Droits',
      Description: 'Mapping : unit-es-mapping.json. Mandat octroyé à la personne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Mandate',
      ApiField: 'Mandate',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Transmitter.Mandate',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Transmitter.Nationality',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Nationality',
      ShortName: 'nationalité',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Nationality',
      ApiField: 'Nationality',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Transmitter.Nationality',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Transmitter.Position',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Position',
      ShortName: 'Position',
      Description: 'Mapping : unit-es-mapping.json. Intitulé du poste de travail occupé par la personne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Position',
      ApiField: 'Position',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Transmitter.Position',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Transmitter.Role',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Role',
      ShortName: 'Rôle',
      Description:
        'Mapping : unit-es-mapping.json. Droits avec lesquels un utilisateur a réalisé une opération, notamment dans une application.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Role',
      ApiField: 'Role',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Transmitter.Role',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Type',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Type',
      ShortName: "Type d'information",
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Type',
      ApiField: 'Type',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Type',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Version',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Version',
      ShortName: 'Version',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Version',
      ApiField: 'Version',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Version',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Writer',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'Writer',
      ShortName: 'Rédacteur',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Writer',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Writer',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'Writer.Activity',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Activity',
      ShortName: 'Activité',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Activité.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Activity',
      ApiField: 'Activity',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Writer.Activity',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Writer.BirthDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'BirthDate',
      ShortName: 'Date de naissance',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'BirthDate',
      ApiField: 'BirthDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Writer.BirthDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: 'Writer.BirthName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'BirthName',
      ShortName: 'Nom de naissance',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'BirthName',
      ApiField: 'BirthName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Writer.BirthName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Writer.BirthPlace',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'BirthPlace',
      ShortName: 'Lieu de naissance',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'BirthPlace',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Writer.BirthPlace',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'Writer.BirthPlace.Address',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Address',
      ShortName: 'Adresse',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Adresse. Références : ead.address",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Address',
      ApiField: 'Address',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Writer.BirthPlace.Address',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Writer.BirthPlace.City',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'City',
      ShortName: 'Ville',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Ville.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'City',
      ApiField: 'City',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Writer.BirthPlace.City',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Writer.BirthPlace.Country',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Country',
      ShortName: 'Pays',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Pays.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Country',
      ApiField: 'Country',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Writer.BirthPlace.Country',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Writer.BirthPlace.Geogname',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Geogname',
      ShortName: 'Nom de lieu',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Nom géographique. Références : ead.geogname",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Geogname',
      ApiField: 'Geogname',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Writer.BirthPlace.Geogname',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Writer.BirthPlace.PostalCode',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'PostalCode',
      ShortName: 'Code postal',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Code postal.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'PostalCode',
      ApiField: 'PostalCode',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Writer.BirthPlace.PostalCode',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Writer.BirthPlace.Region',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Region',
      ShortName: 'Région',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Région.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Region',
      ApiField: 'Region',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Writer.BirthPlace.Region',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Writer.Corpname',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Corpname',
      ShortName: "Nom de l'entité",
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Corpname',
      ApiField: 'Corpname',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Writer.Corpname',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Writer.DeathDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'DeathDate',
      ShortName: 'date de décès',
      Description: "Mapping : unit-es-mapping.json. Date de décès d'une personne.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'DeathDate',
      ApiField: 'DeathDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Writer.DeathDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: 'Writer.DeathPlace',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'DeathPlace',
      ShortName: 'Lieu de décès',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'DeathPlace',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Writer.DeathPlace',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: 'Writer.DeathPlace.Address',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Address',
      ShortName: 'Adresse',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Adresse. Références : ead.address",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Address',
      ApiField: 'Address',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Writer.DeathPlace.Address',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Writer.DeathPlace.City',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'City',
      ShortName: 'Ville',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Ville.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'City',
      ApiField: 'City',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Writer.DeathPlace.City',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Writer.DeathPlace.Country',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Country',
      ShortName: 'Pays',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Pays.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Country',
      ApiField: 'Country',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Writer.DeathPlace.Country',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Writer.DeathPlace.Geogname',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Geogname',
      ShortName: 'Nom de lieu',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Nom géographique. Références : ead.geogname",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Geogname',
      ApiField: 'Geogname',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Writer.DeathPlace.Geogname',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Writer.DeathPlace.PostalCode',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'PostalCode',
      ShortName: 'Code postal',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Code postal.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'PostalCode',
      ApiField: 'PostalCode',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Writer.DeathPlace.PostalCode',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Writer.DeathPlace.Region',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Region',
      ShortName: 'Région',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Région.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Region',
      ApiField: 'Region',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Writer.DeathPlace.Region',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Writer.FirstName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'FirstName',
      ShortName: 'Prénom',
      Description: "Mapping : unit-es-mapping.json. Prénom d'une personne.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'FirstName',
      ApiField: 'FirstName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Writer.FirstName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Writer.FullName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'FullName',
      ShortName: 'Nom complet',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'FullName',
      ApiField: 'FullName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Writer.FullName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Writer.Function',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Function',
      ShortName: 'Fonction',
      Description:
        "Mapping : unit-es-mapping.json. En plus des balises Tag et Keyword, il est possible d'indexer les objets avec des éléments pré-définis : Fonction.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Function',
      ApiField: 'Function',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Writer.Function',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Writer.Gender',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'Gender',
      ShortName: 'Sexe',
      Description: 'Mapping : unit-es-mapping.json. Sexe de la personne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Gender',
      ApiField: 'Gender',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Writer.Gender',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Writer.GivenName',
      StringSize: 'SHORT',
      Cardinality: 'ONE',
      FieldName: 'GivenName',
      ShortName: "Nom d'usage",
      Description: "Mapping : unit-es-mapping.json. Nom d'usage d'une personne.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'GivenName',
      ApiField: 'GivenName',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Writer.GivenName',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Writer.Identifier',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Identifier',
      ShortName: 'Identifiant',
      Description:
        "Mapping : unit-es-mapping.json. UNITE ARCHIVISTIQUE : Dans le PersonGroup, Identifiant de type numéro matricule. Dans le EntityGroup, Identifiant de l'entité. REFERENTIELS : identifiant.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Identifier',
      ApiField: 'Identifier',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Writer.Identifier',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Writer.Mandate',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Mandate',
      ShortName: 'Droits',
      Description: 'Mapping : unit-es-mapping.json. Mandat octroyé à la personne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Mandate',
      ApiField: 'Mandate',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Writer.Mandate',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Writer.Nationality',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Nationality',
      ShortName: 'nationalité',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Nationality',
      ApiField: 'Nationality',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Writer.Nationality',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Writer.Position',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Position',
      ShortName: 'Position',
      Description: 'Mapping : unit-es-mapping.json. Intitulé du poste de travail occupé par la personne.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Position',
      ApiField: 'Position',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Writer.Position',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'Writer.Role',
      StringSize: 'SHORT',
      Cardinality: 'MANY',
      FieldName: 'Role',
      ShortName: 'Rôle',
      Description:
        'Mapping : unit-es-mapping.json. Droits avec lesquels un utilisateur a réalisé une opération, notamment dans une application.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Role',
      ApiField: 'Role',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'DESCRIPTION',
      ApiPath: 'Writer.Role',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_acd',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: '_acd',
      ShortName: '_acd',
      Description: 'Approximative created date, Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: '#approximate_creation_date',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'OTHER',
      ApiPath: '#approximate_creation_date',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_aud',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: '_aud',
      ShortName: '_aud',
      Description: 'Approximative updated date, Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: '#approximate_update_date',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'OTHER',
      ApiPath: '#approximate_update_date',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_av',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: '_av',
      ShortName: 'Version',
      Description: 'Version interne de l’enregistrement décrit.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: '#atomic_version',
      Type: 'LONG',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'OTHER',
      ApiPath: '#atomic_version',
      DataType: 'LONG',
    },
    {
      id: null,
      Path: '_computedInheritedRules',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: '_computedInheritedRules',
      ShortName: '_computedInheritedRules',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: '#computedInheritedRules',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_computedInheritedRules.AccessRule',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'AccessRule',
      ShortName: 'AccessRule',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'AccessRule',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.AccessRule',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_computedInheritedRules.AccessRule.EndDates',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'EndDates',
      ShortName: 'EndDates',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'EndDates',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.AccessRule.EndDates',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_computedInheritedRules.AccessRule.InheritanceOrigin',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'InheritanceOrigin',
      ShortName: 'InheritanceOrigin',
      Description: 'Origine de définition des règles de gestion',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'InheritanceOrigin',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.AccessRule.InheritanceOrigin',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_computedInheritedRules.AccessRule.InheritedRuleIds',
      StringSize: 'MEDIUM',
      Cardinality: 'MANY',
      FieldName: 'InheritedRuleIds',
      ShortName: 'InheritedRuleIds',
      Description: 'Identifiant des règles héritées applicables',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'InheritedRuleIds',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.AccessRule.InheritedRuleIds',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_computedInheritedRules.AccessRule.MaxEndDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'MaxEndDate',
      ShortName: 'MaxEndDate',
      Description: 'Date de fin maximale',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'MaxEndDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.AccessRule.MaxEndDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_computedInheritedRules.AccessRule.Rules',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'Rules',
      ShortName: 'Rules',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Rules',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.AccessRule.Rules',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_computedInheritedRules.AccessRule.Rules.EndDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'EndDate',
      ShortName: 'Date de fin',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'EndDate',
      ApiField: 'EndDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.AccessRule.Rules.EndDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_computedInheritedRules.AccessRule.Rules.Rule',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'Rule',
      ShortName: 'Règle de gestion',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Rule',
      ApiField: 'Rule',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.AccessRule.Rules.Rule',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_computedInheritedRules.AppraisalRule',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'AppraisalRule',
      ShortName: 'AppraisalRule',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'AppraisalRule',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.AppraisalRule',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_computedInheritedRules.AppraisalRule.EndDates',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'EndDates',
      ShortName: 'EndDates',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'EndDates',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.AppraisalRule.EndDates',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_computedInheritedRules.AppraisalRule.FinalAction',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'FinalAction',
      ShortName: 'Sort final',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'FinalAction',
      ApiField: 'FinalAction',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.AppraisalRule.FinalAction',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_computedInheritedRules.AppraisalRule.InheritanceOrigin',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'InheritanceOrigin',
      ShortName: 'InheritanceOrigin',
      Description: 'Origine de définition des règles de gestion',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'InheritanceOrigin',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.AppraisalRule.InheritanceOrigin',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_computedInheritedRules.AppraisalRule.InheritedRuleIds',
      StringSize: 'MEDIUM',
      Cardinality: 'MANY',
      FieldName: 'InheritedRuleIds',
      ShortName: 'InheritedRuleIds',
      Description: 'Identifiant des règles héritées applicables',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'InheritedRuleIds',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.AppraisalRule.InheritedRuleIds',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_computedInheritedRules.AppraisalRule.MaxEndDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'MaxEndDate',
      ShortName: 'MaxEndDate',
      Description: 'Date de fin maximale',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'MaxEndDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.AppraisalRule.MaxEndDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_computedInheritedRules.AppraisalRule.Rules',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'Rules',
      ShortName: 'Rules',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Rules',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.AppraisalRule.Rules',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_computedInheritedRules.AppraisalRule.Rules.EndDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'EndDate',
      ShortName: 'Date de fin',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'EndDate',
      ApiField: 'EndDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.AppraisalRule.Rules.EndDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_computedInheritedRules.AppraisalRule.Rules.Rule',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'Rule',
      ShortName: 'Règle de gestion',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Rule',
      ApiField: 'Rule',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.AppraisalRule.Rules.Rule',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_computedInheritedRules.ClassificationRule',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'ClassificationRule',
      ShortName: 'ClassificationRule',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'ClassificationRule',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.ClassificationRule',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_computedInheritedRules.ClassificationRule.EndDates',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'EndDates',
      ShortName: 'EndDates',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'EndDates',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.ClassificationRule.EndDates',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_computedInheritedRules.ClassificationRule.InheritanceOrigin',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'InheritanceOrigin',
      ShortName: 'InheritanceOrigin',
      Description: 'Origine de définition des règles de gestion',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'InheritanceOrigin',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.ClassificationRule.InheritanceOrigin',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_computedInheritedRules.ClassificationRule.InheritedRuleIds',
      StringSize: 'MEDIUM',
      Cardinality: 'MANY',
      FieldName: 'InheritedRuleIds',
      ShortName: 'InheritedRuleIds',
      Description: 'Identifiant des règles héritées applicables',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'InheritedRuleIds',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.ClassificationRule.InheritedRuleIds',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_computedInheritedRules.ClassificationRule.MaxEndDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'MaxEndDate',
      ShortName: 'MaxEndDate',
      Description: 'Date de fin maximale',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'MaxEndDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.ClassificationRule.MaxEndDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_computedInheritedRules.ClassificationRule.Rules',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'Rules',
      ShortName: 'Rules',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Rules',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.ClassificationRule.Rules',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_computedInheritedRules.ClassificationRule.Rules.EndDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'EndDate',
      ShortName: 'Date de fin',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'EndDate',
      ApiField: 'EndDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.ClassificationRule.Rules.EndDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_computedInheritedRules.ClassificationRule.Rules.Rule',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'Rule',
      ShortName: 'Règle de gestion',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Rule',
      ApiField: 'Rule',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.ClassificationRule.Rules.Rule',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_computedInheritedRules.DisseminationRule',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'DisseminationRule',
      ShortName: 'DisseminationRule',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'DisseminationRule',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.DisseminationRule',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_computedInheritedRules.DisseminationRule.EndDates',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'EndDates',
      ShortName: 'EndDates',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'EndDates',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.DisseminationRule.EndDates',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_computedInheritedRules.DisseminationRule.InheritanceOrigin',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'InheritanceOrigin',
      ShortName: 'InheritanceOrigin',
      Description: 'Origine de définition des règles de gestion',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'InheritanceOrigin',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.DisseminationRule.InheritanceOrigin',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_computedInheritedRules.DisseminationRule.InheritedRuleIds',
      StringSize: 'MEDIUM',
      Cardinality: 'MANY',
      FieldName: 'InheritedRuleIds',
      ShortName: 'InheritedRuleIds',
      Description: 'Identifiant des règles héritées applicables',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'InheritedRuleIds',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.DisseminationRule.InheritedRuleIds',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_computedInheritedRules.DisseminationRule.MaxEndDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'MaxEndDate',
      ShortName: 'MaxEndDate',
      Description: 'Date de fin maximale',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'MaxEndDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.DisseminationRule.MaxEndDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_computedInheritedRules.DisseminationRule.Rules',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'Rules',
      ShortName: 'Rules',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Rules',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.DisseminationRule.Rules',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_computedInheritedRules.DisseminationRule.Rules.EndDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'EndDate',
      ShortName: 'Date de fin',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'EndDate',
      ApiField: 'EndDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.DisseminationRule.Rules.EndDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_computedInheritedRules.DisseminationRule.Rules.Rule',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'Rule',
      ShortName: 'Règle de gestion',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Rule',
      ApiField: 'Rule',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.DisseminationRule.Rules.Rule',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_computedInheritedRules.HoldRule',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'HoldRule',
      ShortName: 'HoldRule',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'HoldRule',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.HoldRule',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_computedInheritedRules.HoldRule.EndDates',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'EndDates',
      ShortName: 'EndDates',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'EndDates',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.HoldRule.EndDates',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_computedInheritedRules.HoldRule.InheritanceOrigin',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'InheritanceOrigin',
      ShortName: 'InheritanceOrigin',
      Description: 'Origine de définition des règles de gestion',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'InheritanceOrigin',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.HoldRule.InheritanceOrigin',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_computedInheritedRules.HoldRule.InheritedRuleIds',
      StringSize: 'MEDIUM',
      Cardinality: 'MANY',
      FieldName: 'InheritedRuleIds',
      ShortName: 'InheritedRuleIds',
      Description: 'Identifiant des règles héritées applicables',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'InheritedRuleIds',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.HoldRule.InheritedRuleIds',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_computedInheritedRules.HoldRule.MaxEndDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'MaxEndDate',
      ShortName: 'MaxEndDate',
      Description: 'Date de fin maximale',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'MaxEndDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.HoldRule.MaxEndDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_computedInheritedRules.HoldRule.Rules',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'Rules',
      ShortName: 'Rules',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Rules',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.HoldRule.Rules',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_computedInheritedRules.HoldRule.Rules.EndDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'EndDate',
      ShortName: 'Date de fin',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'EndDate',
      ApiField: 'EndDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.HoldRule.Rules.EndDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_computedInheritedRules.HoldRule.Rules.Rule',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'Rule',
      ShortName: 'Règle de gestion',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Rule',
      ApiField: 'Rule',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.HoldRule.Rules.Rule',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_computedInheritedRules.NeedAuthorization',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'NeedAuthorization',
      ShortName: 'Autorisation',
      Description:
        'Mapping : unit-es-mapping.json. Indique si une autorisation humaine est nécessaire pour vérifier ou valider les opérations de gestion des ArchiveUnit.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'NeedAuthorization',
      ApiField: 'NeedAuthorization',
      Type: 'BOOLEAN',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.NeedAuthorization',
      DataType: 'BOOLEAN',
    },
    {
      id: null,
      Path: '_computedInheritedRules.ReuseRule',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'ReuseRule',
      ShortName: 'ReuseRule',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'ReuseRule',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.ReuseRule',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_computedInheritedRules.ReuseRule.EndDates',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'EndDates',
      ShortName: 'EndDates',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'EndDates',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.ReuseRule.EndDates',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_computedInheritedRules.ReuseRule.InheritanceOrigin',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'InheritanceOrigin',
      ShortName: 'InheritanceOrigin',
      Description: 'Origine de définition des règles de gestion',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'InheritanceOrigin',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.ReuseRule.InheritanceOrigin',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_computedInheritedRules.ReuseRule.InheritedRuleIds',
      StringSize: 'MEDIUM',
      Cardinality: 'MANY',
      FieldName: 'InheritedRuleIds',
      ShortName: 'InheritedRuleIds',
      Description: 'Identifiant des règles héritées applicables',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'InheritedRuleIds',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.ReuseRule.InheritedRuleIds',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_computedInheritedRules.ReuseRule.MaxEndDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'MaxEndDate',
      ShortName: 'MaxEndDate',
      Description: 'Date de fin maximale',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'MaxEndDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.ReuseRule.MaxEndDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_computedInheritedRules.ReuseRule.Rules',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'Rules',
      ShortName: 'Rules',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Rules',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.ReuseRule.Rules',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_computedInheritedRules.ReuseRule.Rules.EndDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'EndDate',
      ShortName: 'Date de fin',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'EndDate',
      ApiField: 'EndDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.ReuseRule.Rules.EndDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_computedInheritedRules.ReuseRule.Rules.Rule',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'Rule',
      ShortName: 'Règle de gestion',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Rule',
      ApiField: 'Rule',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.ReuseRule.Rules.Rule',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_computedInheritedRules.StorageRule',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'StorageRule',
      ShortName: 'StorageRule',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'StorageRule',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.StorageRule',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_computedInheritedRules.StorageRule.EndDates',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'EndDates',
      ShortName: 'EndDates',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'EndDates',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.StorageRule.EndDates',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_computedInheritedRules.StorageRule.FinalAction',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'FinalAction',
      ShortName: 'Sort final',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'FinalAction',
      ApiField: 'FinalAction',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.StorageRule.FinalAction',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_computedInheritedRules.StorageRule.InheritanceOrigin',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'InheritanceOrigin',
      ShortName: 'InheritanceOrigin',
      Description: 'Origine de définition des règles de gestion',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'InheritanceOrigin',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.StorageRule.InheritanceOrigin',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_computedInheritedRules.StorageRule.InheritedRuleIds',
      StringSize: 'MEDIUM',
      Cardinality: 'MANY',
      FieldName: 'InheritedRuleIds',
      ShortName: 'InheritedRuleIds',
      Description: 'Identifiant des règles héritées applicables',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'InheritedRuleIds',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.StorageRule.InheritedRuleIds',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_computedInheritedRules.StorageRule.MaxEndDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'MaxEndDate',
      ShortName: 'MaxEndDate',
      Description: 'Date de fin maximale',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'MaxEndDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.StorageRule.MaxEndDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_computedInheritedRules.StorageRule.Rules',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'Rules',
      ShortName: 'Rules',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Rules',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.StorageRule.Rules',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_computedInheritedRules.StorageRule.Rules.EndDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'EndDate',
      ShortName: 'Date de fin',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'EndDate',
      ApiField: 'EndDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.StorageRule.Rules.EndDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_computedInheritedRules.StorageRule.Rules.Rule',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'Rule',
      ShortName: 'Règle de gestion',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Rule',
      ApiField: 'Rule',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.StorageRule.Rules.Rule',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_computedInheritedRules.indexationDate',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'indexationDate',
      ShortName: 'indexationDate',
      Description: "Date d'indexation'",
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'indexationDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.indexationDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_computedInheritedRules.inheritedRulesAPIOutput',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'inheritedRulesAPIOutput',
      ShortName: 'inheritedRulesAPIOutput',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'inheritedRulesAPIOutput',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#computedInheritedRules.inheritedRulesAPIOutput',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_elimination',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: '_elimination',
      ShortName: '_elimination',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: '#elimination',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#elimination',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_elimination.DestroyableOriginatingAgencies',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'DestroyableOriginatingAgencies',
      ShortName: 'DestroyableOriginatingAgencies',
      Description: 'Mapping : unit-es-mapping.json. Services producteurs éliminables',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'DestroyableOriginatingAgencies',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#elimination.DestroyableOriginatingAgencies',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_elimination.ExtendedInfo',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'ExtendedInfo',
      ShortName: 'ExtendedInfo',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'ExtendedInfo',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#elimination.ExtendedInfo',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_elimination.ExtendedInfo.ExtendedInfoDetails',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'ExtendedInfoDetails',
      ShortName: 'ExtendedInfoDetails',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'ExtendedInfoDetails',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#elimination.ExtendedInfo.ExtendedInfoDetails',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_elimination.ExtendedInfo.ExtendedInfoDetails.DestroyableOriginatingAgencies',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'DestroyableOriginatingAgencies',
      ShortName: 'DestroyableOriginatingAgencies',
      Description: 'Mapping : unit-es-mapping.json. Services producteurs éliminables',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'DestroyableOriginatingAgencies',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#elimination.ExtendedInfo.ExtendedInfoDetails.DestroyableOriginatingAgencies',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_elimination.ExtendedInfo.ExtendedInfoDetails.HoldRuleIds',
      StringSize: 'MEDIUM',
      Cardinality: 'MANY',
      FieldName: 'HoldRuleIds',
      ShortName: 'HoldRuleIds',
      Description: 'Mapping : unit-es-mapping.json. Identifiants des règles de gel',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'HoldRuleIds',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#elimination.ExtendedInfo.ExtendedInfoDetails.HoldRuleIds',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_elimination.ExtendedInfo.ExtendedInfoDetails.NonDestroyableOriginatingAgencies',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'NonDestroyableOriginatingAgencies',
      ShortName: 'NonDestroyableOriginatingAgencies',
      Description: 'Mapping : unit-es-mapping.json. Services producteurs non éliminables',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'NonDestroyableOriginatingAgencies',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#elimination.ExtendedInfo.ExtendedInfoDetails.NonDestroyableOriginatingAgencies',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_elimination.ExtendedInfo.ExtendedInfoDetails.OriginatingAgenciesInConflict',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'OriginatingAgenciesInConflict',
      ShortName: 'OriginatingAgenciesInConflict',
      Description: 'Mapping : unit-es-mapping.json. Services producteurs en conflit',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'OriginatingAgenciesInConflict',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#elimination.ExtendedInfo.ExtendedInfoDetails.OriginatingAgenciesInConflict',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_elimination.ExtendedInfo.ExtendedInfoDetails.ParentUnitId',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'ParentUnitId',
      ShortName: 'ParentUnitId',
      Description: "Mapping : unit-es-mapping.json. Identifiant de l'unité parente",
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'ParentUnitId',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#elimination.ExtendedInfo.ExtendedInfoDetails.ParentUnitId',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_elimination.ExtendedInfo.ExtendedInfoType',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'ExtendedInfoType',
      ShortName: 'ExtendedInfoType',
      Description: "Mapping : unit-es-mapping.json. Type d'informations étendues",
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'ExtendedInfoType',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#elimination.ExtendedInfo.ExtendedInfoType',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_elimination.GlobalStatus',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'GlobalStatus',
      ShortName: 'GlobalStatus',
      Description: "Mapping : unit-es-mapping.json. Statut global de l'indexation.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'GlobalStatus',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#elimination.GlobalStatus',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_elimination.NonDestroyableOriginatingAgencies',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'NonDestroyableOriginatingAgencies',
      ShortName: 'NonDestroyableOriginatingAgencies',
      Description: 'Mapping : unit-es-mapping.json. Services producteurs non éliminables',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'NonDestroyableOriginatingAgencies',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#elimination.NonDestroyableOriginatingAgencies',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_elimination.OperationId',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'OperationId',
      ShortName: 'OperationId',
      Description: "Mapping : unit-es-mapping.json. Identifiant de l'operation.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'OperationId',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#elimination.OperationId',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_glpd',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: '_glpd',
      ShortName: '_glpd',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: '#graph_last_persisted_date',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'OTHER',
      ApiPath: '#graph_last_persisted_date',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_graph',
      StringSize: 'MEDIUM',
      Cardinality: 'MANY',
      FieldName: '_graph',
      ShortName: '_graph',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: '#graph',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'OTHER',
      ApiPath: '#graph',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_history',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: '_history',
      ShortName: '_history',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: '#history',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#history',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_history.data',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'data',
      ShortName: 'data',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'data',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#history.data',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_history.data._mgt',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: '_mgt',
      ShortName: '_mgt',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: '#management',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#history.data.#management',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_history.data._mgt.ClassificationRule',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'ClassificationRule',
      ShortName: 'ClassificationRule',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'ClassificationRule',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#history.data.#management.ClassificationRule',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_history.data._mgt.ClassificationRule.ClassificationAudience',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'ClassificationAudience',
      ShortName: 'Audience de la classification',
      Description:
        "Mapping : unit-es-mapping.json. Permet de gérer les questions de 'diffusion restreinte', de 'spécial France' et de 'Confidentiel Industrie'.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'ClassificationAudience',
      ApiField: 'ClassificationAudience',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#history.data.#management.ClassificationRule.ClassificationAudience',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_history.data._mgt.ClassificationRule.ClassificationLevel',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'ClassificationLevel',
      ShortName: 'Niveau de classification',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'ClassificationLevel',
      ApiField: 'ClassificationLevel',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#history.data.#management.ClassificationRule.ClassificationLevel',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_history.data._mgt.ClassificationRule.ClassificationOwner',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'ClassificationOwner',
      ShortName: 'Service émetteur / Propriétaire de la classification',
      Description: "Mapping : unit-es-mapping.json. Propriétaire de la classification. Service émetteur au sens de l'IGI 1300.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'ClassificationOwner',
      ApiField: 'ClassificationOwner',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#history.data.#management.ClassificationRule.ClassificationOwner',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_history.data._mgt.ClassificationRule.ClassificationReassessingDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'ClassificationReassessingDate',
      ShortName: 'Date de réévaluation',
      Description: 'Mapping : unit-es-mapping.json. Date de réévaluation de la classification.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'ClassificationReassessingDate',
      ApiField: 'ClassificationReassessingDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#history.data.#management.ClassificationRule.ClassificationReassessingDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_history.data._mgt.ClassificationRule.Inheritance',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'Inheritance',
      ShortName: 'Inheritance',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Inheritance',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#history.data.#management.ClassificationRule.Inheritance',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_history.data._mgt.ClassificationRule.Inheritance.PreventInheritance',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'PreventInheritance',
      ShortName: "Ignorer l'héritage",
      Description:
        "Mapping : unit-es-mapping.json. Indique si les règles de gestion héritées des ArchiveUnit parents doivent être ignorées pour l'ArchiveUnit concerné.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'PreventInheritance',
      ApiField: 'PreventInheritance',
      Type: 'BOOLEAN',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#history.data.#management.ClassificationRule.Inheritance.PreventInheritance',
      DataType: 'BOOLEAN',
    },
    {
      id: null,
      Path: '_history.data._mgt.ClassificationRule.Inheritance.PreventRulesId',
      StringSize: 'MEDIUM',
      Cardinality: 'MANY',
      FieldName: 'PreventRulesId',
      ShortName: 'Bloquer la règle',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'RefNonRuleId',
      ApiField: 'PreventRulesId',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#history.data.#management.ClassificationRule.Inheritance.PreventRulesId',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_history.data._mgt.ClassificationRule.NeedReassessingAuthorization',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'NeedReassessingAuthorization',
      ShortName: 'Autorisation',
      Description: 'Mapping : unit-es-mapping.json. Indique si une autorisation humaine est nécessaire pour réévaluer la classification.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'NeedReassessingAuthorization',
      ApiField: 'NeedReassessingAuthorization',
      Type: 'BOOLEAN',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#history.data.#management.ClassificationRule.NeedReassessingAuthorization',
      DataType: 'BOOLEAN',
    },
    {
      id: null,
      Path: '_history.data._mgt.ClassificationRule.Rules',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'Rules',
      ShortName: 'Rules',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Rules',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#history.data.#management.ClassificationRule.Rules',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_history.data._mgt.ClassificationRule.Rules.EndDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'EndDate',
      ShortName: 'Date de fin',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'EndDate',
      ApiField: 'EndDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#history.data.#management.ClassificationRule.Rules.EndDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_history.data._mgt.ClassificationRule.Rules.Rule',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'Rule',
      ShortName: 'Règle de gestion',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Rule',
      ApiField: 'Rule',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#history.data.#management.ClassificationRule.Rules.Rule',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_history.data._mgt.ClassificationRule.Rules.StartDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'StartDate',
      ShortName: 'Date de début',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'StartDate',
      ApiField: 'StartDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#history.data.#management.ClassificationRule.Rules.StartDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_history.data._v',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: '_v',
      ShortName: 'Version',
      Description: 'Mapping : unit-es-mapping.json. Version de l’enregistrement décrit.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: '#version',
      Type: 'LONG',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#history.data.#version',
      DataType: 'LONG',
    },
    {
      id: null,
      Path: '_history.ud',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'ud',
      ShortName: 'Dernière modification',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'ud',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#history.ud',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_id',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: '_id',
      ShortName: "Identifiant du groupe d'objets",
      Description: 'Mapping : og-es-mapping.json. Identifiant du groupe d’objets',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: '#id',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'OTHER',
      ApiPath: '#id',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_implementationVersion',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: '_implementationVersion',
      ShortName: '_implementationVersion',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: '#implementationVersion',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'OTHER',
      ApiPath: '#implementationVersion',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_max',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: '_max',
      ShortName: 'Profondeur maximale',
      Description: 'Mapping : unit-es-mapping.json. Profondeur maximale de l’unité archivistique par rapport à une racine.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: '#max',
      Type: 'LONG',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'OTHER',
      ApiPath: '#max',
      DataType: 'LONG',
    },
    {
      id: null,
      Path: '_mgt',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: '_mgt',
      ShortName: '_mgt',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: '#management',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_mgt.AccessRule',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'AccessRule',
      ShortName: 'AccessRule',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'AccessRule',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.AccessRule',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_mgt.AccessRule.Inheritance',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'Inheritance',
      ShortName: 'Inheritance',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Inheritance',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.AccessRule.Inheritance',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_mgt.AccessRule.Inheritance.PreventInheritance',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'PreventInheritance',
      ShortName: "Ignorer l'héritage",
      Description:
        "Mapping : unit-es-mapping.json. Indique si les règles de gestion héritées des ArchiveUnit parents doivent être ignorées pour l'ArchiveUnit concerné.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'PreventInheritance',
      ApiField: 'PreventInheritance',
      Type: 'BOOLEAN',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.AccessRule.Inheritance.PreventInheritance',
      DataType: 'BOOLEAN',
    },
    {
      id: null,
      Path: '_mgt.AccessRule.Inheritance.PreventRulesId',
      StringSize: 'MEDIUM',
      Cardinality: 'MANY',
      FieldName: 'PreventRulesId',
      ShortName: 'Bloquer la règle',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'RefNonRuleId',
      ApiField: 'PreventRulesId',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.AccessRule.Inheritance.PreventRulesId',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_mgt.AccessRule.Rules',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'Rules',
      ShortName: 'Rules',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Rules',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.AccessRule.Rules',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_mgt.AccessRule.Rules.EndDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'EndDate',
      ShortName: 'Date de fin',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'EndDate',
      ApiField: 'EndDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.AccessRule.Rules.EndDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_mgt.AccessRule.Rules.Rule',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'Rule',
      ShortName: 'Règle de gestion',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Rule',
      ApiField: 'Rule',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.AccessRule.Rules.Rule',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_mgt.AccessRule.Rules.StartDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'StartDate',
      ShortName: 'Date de début',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'StartDate',
      ApiField: 'StartDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.AccessRule.Rules.StartDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_mgt.AppraisalRule',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'AppraisalRule',
      ShortName: 'AppraisalRule',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'AppraisalRule',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.AppraisalRule',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_mgt.AppraisalRule.FinalAction',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'FinalAction',
      ShortName: 'Sort final',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'FinalAction',
      ApiField: 'FinalAction',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.AppraisalRule.FinalAction',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_mgt.AppraisalRule.Inheritance',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'Inheritance',
      ShortName: 'Inheritance',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Inheritance',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.AppraisalRule.Inheritance',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_mgt.AppraisalRule.Inheritance.PreventInheritance',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'PreventInheritance',
      ShortName: "Ignorer l'héritage",
      Description:
        "Mapping : unit-es-mapping.json. Indique si les règles de gestion héritées des ArchiveUnit parents doivent être ignorées pour l'ArchiveUnit concerné.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'PreventInheritance',
      ApiField: 'PreventInheritance',
      Type: 'BOOLEAN',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.AppraisalRule.Inheritance.PreventInheritance',
      DataType: 'BOOLEAN',
    },
    {
      id: null,
      Path: '_mgt.AppraisalRule.Inheritance.PreventRulesId',
      StringSize: 'MEDIUM',
      Cardinality: 'MANY',
      FieldName: 'PreventRulesId',
      ShortName: 'Bloquer la règle',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'RefNonRuleId',
      ApiField: 'PreventRulesId',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.AppraisalRule.Inheritance.PreventRulesId',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_mgt.AppraisalRule.Rules',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'Rules',
      ShortName: 'Rules',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Rules',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.AppraisalRule.Rules',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_mgt.AppraisalRule.Rules.EndDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'EndDate',
      ShortName: 'Date de fin',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'EndDate',
      ApiField: 'EndDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.AppraisalRule.Rules.EndDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_mgt.AppraisalRule.Rules.Rule',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'Rule',
      ShortName: 'Règle de gestion',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Rule',
      ApiField: 'Rule',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.AppraisalRule.Rules.Rule',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_mgt.AppraisalRule.Rules.StartDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'StartDate',
      ShortName: 'Date de début',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'StartDate',
      ApiField: 'StartDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.AppraisalRule.Rules.StartDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_mgt.ClassificationRule',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'ClassificationRule',
      ShortName: 'ClassificationRule',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'ClassificationRule',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.ClassificationRule',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_mgt.ClassificationRule.ClassificationAudience',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'ClassificationAudience',
      ShortName: 'Audience de la classification',
      Description:
        "Mapping : unit-es-mapping.json. Permet de gérer les questions de 'diffusion restreinte', de 'spécial France' et de 'Confidentiel Industrie'.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'ClassificationAudience',
      ApiField: 'ClassificationAudience',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.ClassificationRule.ClassificationAudience',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_mgt.ClassificationRule.ClassificationLevel',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'ClassificationLevel',
      ShortName: 'Niveau de classification',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'ClassificationLevel',
      ApiField: 'ClassificationLevel',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.ClassificationRule.ClassificationLevel',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_mgt.ClassificationRule.ClassificationOwner',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'ClassificationOwner',
      ShortName: 'Service émetteur / Propriétaire de la classification',
      Description: "Mapping : unit-es-mapping.json. Propriétaire de la classification. Service émetteur au sens de l'IGI 1300.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'ClassificationOwner',
      ApiField: 'ClassificationOwner',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.ClassificationRule.ClassificationOwner',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_mgt.ClassificationRule.ClassificationReassessingDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'ClassificationReassessingDate',
      ShortName: 'Date de réévaluation',
      Description: 'Mapping : unit-es-mapping.json. Date de réévaluation de la classification.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'ClassificationReassessingDate',
      ApiField: 'ClassificationReassessingDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.ClassificationRule.ClassificationReassessingDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_mgt.ClassificationRule.Inheritance',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'Inheritance',
      ShortName: 'Inheritance',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Inheritance',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.ClassificationRule.Inheritance',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_mgt.ClassificationRule.Inheritance.PreventInheritance',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'PreventInheritance',
      ShortName: "Ignorer l'héritage",
      Description:
        "Mapping : unit-es-mapping.json. Indique si les règles de gestion héritées des ArchiveUnit parents doivent être ignorées pour l'ArchiveUnit concerné.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'PreventInheritance',
      ApiField: 'PreventInheritance',
      Type: 'BOOLEAN',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.ClassificationRule.Inheritance.PreventInheritance',
      DataType: 'BOOLEAN',
    },
    {
      id: null,
      Path: '_mgt.ClassificationRule.Inheritance.PreventRulesId',
      StringSize: 'MEDIUM',
      Cardinality: 'MANY',
      FieldName: 'PreventRulesId',
      ShortName: 'Bloquer la règle',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'RefNonRuleId',
      ApiField: 'PreventRulesId',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.ClassificationRule.Inheritance.PreventRulesId',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_mgt.ClassificationRule.NeedReassessingAuthorization',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'NeedReassessingAuthorization',
      ShortName: 'Autorisation',
      Description: 'Mapping : unit-es-mapping.json. Indique si une autorisation humaine est nécessaire pour réévaluer la classification.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'NeedReassessingAuthorization',
      ApiField: 'NeedReassessingAuthorization',
      Type: 'BOOLEAN',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.ClassificationRule.NeedReassessingAuthorization',
      DataType: 'BOOLEAN',
    },
    {
      id: null,
      Path: '_mgt.ClassificationRule.Rules',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'Rules',
      ShortName: 'Rules',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Rules',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.ClassificationRule.Rules',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_mgt.ClassificationRule.Rules.EndDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'EndDate',
      ShortName: 'Date de fin',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'EndDate',
      ApiField: 'EndDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.ClassificationRule.Rules.EndDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_mgt.ClassificationRule.Rules.Rule',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'Rule',
      ShortName: 'Règle de gestion',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Rule',
      ApiField: 'Rule',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.ClassificationRule.Rules.Rule',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_mgt.ClassificationRule.Rules.StartDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'StartDate',
      ShortName: 'Date de début',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'StartDate',
      ApiField: 'StartDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.ClassificationRule.Rules.StartDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_mgt.DisseminationRule',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'DisseminationRule',
      ShortName: 'DisseminationRule',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'DisseminationRule',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.DisseminationRule',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_mgt.DisseminationRule.Inheritance',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'Inheritance',
      ShortName: 'Inheritance',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Inheritance',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.DisseminationRule.Inheritance',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_mgt.DisseminationRule.Inheritance.PreventInheritance',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'PreventInheritance',
      ShortName: "Ignorer l'héritage",
      Description:
        "Mapping : unit-es-mapping.json. Indique si les règles de gestion héritées des ArchiveUnit parents doivent être ignorées pour l'ArchiveUnit concerné.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'PreventInheritance',
      ApiField: 'PreventInheritance',
      Type: 'BOOLEAN',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.DisseminationRule.Inheritance.PreventInheritance',
      DataType: 'BOOLEAN',
    },
    {
      id: null,
      Path: '_mgt.DisseminationRule.Inheritance.PreventRulesId',
      StringSize: 'MEDIUM',
      Cardinality: 'MANY',
      FieldName: 'PreventRulesId',
      ShortName: 'Bloquer la règle',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'RefNonRuleId',
      ApiField: 'PreventRulesId',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.DisseminationRule.Inheritance.PreventRulesId',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_mgt.DisseminationRule.Rules',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'Rules',
      ShortName: 'Rules',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Rules',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.DisseminationRule.Rules',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_mgt.DisseminationRule.Rules.EndDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'EndDate',
      ShortName: 'Date de fin',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'EndDate',
      ApiField: 'EndDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.DisseminationRule.Rules.EndDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_mgt.DisseminationRule.Rules.Rule',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'Rule',
      ShortName: 'Règle de gestion',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Rule',
      ApiField: 'Rule',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.DisseminationRule.Rules.Rule',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_mgt.DisseminationRule.Rules.StartDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'StartDate',
      ShortName: 'Date de début',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'StartDate',
      ApiField: 'StartDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.DisseminationRule.Rules.StartDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_mgt.HoldRule',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'HoldRule',
      ShortName: 'HoldRule',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'HoldRule',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.HoldRule',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_mgt.HoldRule.Inheritance',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'Inheritance',
      ShortName: 'Inheritance',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Inheritance',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.HoldRule.Inheritance',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_mgt.HoldRule.Inheritance.PreventInheritance',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'PreventInheritance',
      ShortName: "Ignorer l'héritage",
      Description:
        "Mapping : unit-es-mapping.json. Indique si les règles de gestion héritées des ArchiveUnit parents doivent être ignorées pour l'ArchiveUnit concerné.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'PreventInheritance',
      ApiField: 'PreventInheritance',
      Type: 'BOOLEAN',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.HoldRule.Inheritance.PreventInheritance',
      DataType: 'BOOLEAN',
    },
    {
      id: null,
      Path: '_mgt.HoldRule.Inheritance.PreventRulesId',
      StringSize: 'MEDIUM',
      Cardinality: 'MANY',
      FieldName: 'PreventRulesId',
      ShortName: 'Bloquer la règle',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'RefNonRuleId',
      ApiField: 'PreventRulesId',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.HoldRule.Inheritance.PreventRulesId',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_mgt.HoldRule.Rules',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'Rules',
      ShortName: 'Rules',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Rules',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.HoldRule.Rules',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_mgt.HoldRule.Rules.EndDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'EndDate',
      ShortName: 'Date de fin',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'EndDate',
      ApiField: 'EndDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.HoldRule.Rules.EndDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_mgt.HoldRule.Rules.HoldEndDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'HoldEndDate',
      ShortName: 'Date de fin de gel',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'HoldEndDate',
      ApiField: 'HoldEndDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.HoldRule.Rules.HoldEndDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_mgt.HoldRule.Rules.HoldOwner',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'HoldOwner',
      ShortName: 'Propriétaire de la demande de gel',
      Description: 'Mapping : unit-es-mapping.json. Propriétaire de la demande de gel.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'HoldOwner',
      ApiField: 'HoldOwner',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.HoldRule.Rules.HoldOwner',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_mgt.HoldRule.Rules.HoldReason',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'HoldReason',
      ShortName: 'Motif de gel',
      Description: 'Mapping : unit-es-mapping.json. Motif de gel.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'HoldReason',
      ApiField: 'HoldReason',
      Type: 'TEXT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.HoldRule.Rules.HoldReason',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_mgt.HoldRule.Rules.HoldReassessingDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'HoldReassessingDate',
      ShortName: 'Date de réévaluation',
      Description: 'Mapping : unit-es-mapping.json. Date de réévaluation du gel.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'HoldReassessingDate',
      ApiField: 'HoldReassessingDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.HoldRule.Rules.HoldReassessingDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_mgt.HoldRule.Rules.PreventRearrangement',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'PreventRearrangement',
      ShortName: 'Blocage de la reclassification.',
      Description:
        "Mapping : unit-es-mapping.json. Blocage de la reclassification de l'ArchiveUnit lorsque la restriction de gel est effective.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'PreventRearrangement',
      ApiField: 'PreventRearrangement',
      Type: 'BOOLEAN',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.HoldRule.Rules.PreventRearrangement',
      DataType: 'BOOLEAN',
    },
    {
      id: null,
      Path: '_mgt.HoldRule.Rules.Rule',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'Rule',
      ShortName: 'Règle de gestion',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Rule',
      ApiField: 'Rule',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.HoldRule.Rules.Rule',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_mgt.HoldRule.Rules.StartDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'StartDate',
      ShortName: 'Date de début',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'StartDate',
      ApiField: 'StartDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.HoldRule.Rules.StartDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_mgt.NeedAuthorization',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'NeedAuthorization',
      ShortName: 'Autorisation',
      Description:
        'Mapping : unit-es-mapping.json. Indique si une autorisation humaine est nécessaire pour vérifier ou valider les opérations de gestion des ArchiveUnit.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'NeedAuthorization',
      ApiField: 'NeedAuthorization',
      Type: 'BOOLEAN',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.NeedAuthorization',
      DataType: 'BOOLEAN',
    },
    {
      id: null,
      Path: '_mgt.ReuseRule',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'ReuseRule',
      ShortName: 'ReuseRule',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'ReuseRule',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.ReuseRule',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_mgt.ReuseRule.Inheritance',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'Inheritance',
      ShortName: 'Inheritance',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Inheritance',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.ReuseRule.Inheritance',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_mgt.ReuseRule.Inheritance.PreventInheritance',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'PreventInheritance',
      ShortName: "Ignorer l'héritage",
      Description:
        "Mapping : unit-es-mapping.json. Indique si les règles de gestion héritées des ArchiveUnit parents doivent être ignorées pour l'ArchiveUnit concerné.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'PreventInheritance',
      ApiField: 'PreventInheritance',
      Type: 'BOOLEAN',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.ReuseRule.Inheritance.PreventInheritance',
      DataType: 'BOOLEAN',
    },
    {
      id: null,
      Path: '_mgt.ReuseRule.Inheritance.PreventRulesId',
      StringSize: 'MEDIUM',
      Cardinality: 'MANY',
      FieldName: 'PreventRulesId',
      ShortName: 'Bloquer la règle',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'RefNonRuleId',
      ApiField: 'PreventRulesId',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.ReuseRule.Inheritance.PreventRulesId',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_mgt.ReuseRule.Rules',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'Rules',
      ShortName: 'Rules',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Rules',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.ReuseRule.Rules',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_mgt.ReuseRule.Rules.EndDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'EndDate',
      ShortName: 'Date de fin',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'EndDate',
      ApiField: 'EndDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.ReuseRule.Rules.EndDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_mgt.ReuseRule.Rules.Rule',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'Rule',
      ShortName: 'Règle de gestion',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Rule',
      ApiField: 'Rule',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.ReuseRule.Rules.Rule',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_mgt.ReuseRule.Rules.StartDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'StartDate',
      ShortName: 'Date de début',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'StartDate',
      ApiField: 'StartDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.ReuseRule.Rules.StartDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_mgt.StorageRule',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'StorageRule',
      ShortName: 'StorageRule',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'StorageRule',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.StorageRule',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_mgt.StorageRule.FinalAction',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'FinalAction',
      ShortName: 'Sort final',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'FinalAction',
      ApiField: 'FinalAction',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.StorageRule.FinalAction',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_mgt.StorageRule.Inheritance',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'Inheritance',
      ShortName: 'Inheritance',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Inheritance',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.StorageRule.Inheritance',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_mgt.StorageRule.Inheritance.PreventInheritance',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'PreventInheritance',
      ShortName: "Ignorer l'héritage",
      Description:
        "Mapping : unit-es-mapping.json. Indique si les règles de gestion héritées des ArchiveUnit parents doivent être ignorées pour l'ArchiveUnit concerné.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'PreventInheritance',
      ApiField: 'PreventInheritance',
      Type: 'BOOLEAN',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.StorageRule.Inheritance.PreventInheritance',
      DataType: 'BOOLEAN',
    },
    {
      id: null,
      Path: '_mgt.StorageRule.Inheritance.PreventRulesId',
      StringSize: 'MEDIUM',
      Cardinality: 'MANY',
      FieldName: 'PreventRulesId',
      ShortName: 'Bloquer la règle',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'RefNonRuleId',
      ApiField: 'PreventRulesId',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.StorageRule.Inheritance.PreventRulesId',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_mgt.StorageRule.Rules',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'Rules',
      ShortName: 'Rules',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'Rules',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.StorageRule.Rules',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_mgt.StorageRule.Rules.EndDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'EndDate',
      ShortName: 'Date de fin',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'EndDate',
      ApiField: 'EndDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.StorageRule.Rules.EndDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_mgt.StorageRule.Rules.Rule',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'Rule',
      ShortName: 'Règle de gestion',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'Rule',
      ApiField: 'Rule',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.StorageRule.Rules.Rule',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_mgt.StorageRule.Rules.StartDate',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: 'StartDate',
      ShortName: 'Date de début',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'StartDate',
      ApiField: 'StartDate',
      Type: 'DATE',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: ['2.1', '2.2', '2.3'],
      Category: 'MANAGEMENT',
      ApiPath: '#management.StorageRule.Rules.StartDate',
      DataType: 'DATETIME',
    },
    {
      id: null,
      Path: '_min',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: '_min',
      ShortName: 'Profondeur minimale',
      Description: 'Mapping : unit-es-mapping.json. Profondeur minimum de l’unité archivistique par rapport à une racine.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: '#min',
      Type: 'LONG',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'OTHER',
      ApiPath: '#min',
      DataType: 'LONG',
    },
    {
      id: null,
      Path: '_og',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: '_og',
      ShortName: 'Identifiant du groupe d’objets',
      Description: 'Mapping : unit-es-mapping.json. Identifiant du groupe d’objets représentant cette unité archivistique.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: '#object',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'OTHER',
      ApiPath: '#object',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_opi',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: '_opi',
      ShortName: 'Opération initiale',
      Description: 'Mapping : unit-es-mapping.json. Identifiant de l’opération à l’origine de la création de cette unité archivistique.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: '#opi',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'OTHER',
      ApiPath: '#opi',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_ops',
      StringSize: 'MEDIUM',
      Cardinality: 'MANY',
      FieldName: '_ops',
      ShortName: 'Opérations',
      Description: 'Mapping : unit-es-mapping.json. Identifiants d’opérations auxquelles cette unité archivistique a participé.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: '#operations',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'OTHER',
      ApiPath: '#operations',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_opts',
      StringSize: 'MEDIUM',
      Cardinality: 'MANY',
      FieldName: '_opts',
      ShortName: 'Opérations de transfert',
      Description:
        "Mapping : unit-es-mapping.json. Identifiants de l’opération dans laquelle l'unité archivistique est en cours de transfert",
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: '#opts',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'OTHER',
      ApiPath: '#opts',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_sedaVersion',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: '_sedaVersion',
      ShortName: '_sedaVersion',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: '#sedaVersion',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'OTHER',
      ApiPath: '#sedaVersion',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_sp',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE_REQUIRED',
      FieldName: '_sp',
      ShortName: "Service producteur responsable de l'entrée",
      Description:
        'Mapping : unit-es-mapping.json. Service producteur d’origine déclaré lors de la prise en charge de l’unité archivistique par la solution logicielle Vitam.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: 'OriginatingAgencyIdentifier',
      ApiField: '#originating_agency',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'DESCRIPTION',
      ApiPath: '#originating_agency',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_sps',
      StringSize: 'MEDIUM',
      Cardinality: 'MANY_REQUIRED',
      FieldName: '_sps',
      ShortName: "Service(s) producteur(s) ayant des droits sur l'unité",
      Description:
        'Mapping : unit-es-mapping.json. Services producteurs liés à l’unité archivistique suite à un rattachement et ayant des droits d’accès sur celle-ci.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: '#originating_agencies',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'DESCRIPTION',
      ApiPath: '#originating_agencies',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_storage',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: '_storage',
      ShortName: '_storage',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: '#storage',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'OTHER',
      ApiPath: '#storage',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_storage._nbc',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: '_nbc',
      ShortName: 'Nombre d’objets',
      Description: "Mapping : unit-es-mapping.json. Nombre d’objets correspondant à un usage ou à un groupe d'objets.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: '#nbc',
      Type: 'LONG',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'OTHER',
      ApiPath: '#storage.#nbc',
      DataType: 'LONG',
    },
    {
      id: null,
      Path: '_storage.offerIds',
      StringSize: 'MEDIUM',
      Cardinality: 'MANY',
      FieldName: 'offerIds',
      ShortName: 'offerIds',
      Description: 'Mapping : unit-es-mapping.json. Deprecated.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'offerIds',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'OTHER',
      ApiPath: '#storage.offerIds',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_storage.strategyId',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: 'strategyId',
      ShortName: 'strategyId',
      Description: 'Mapping : unit-es-mapping.json',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: 'strategyId',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'OTHER',
      ApiPath: '#storage.strategyId',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_tenant',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: '_tenant',
      ShortName: 'Tenant',
      Description: 'Mapping : unit-es-mapping.json. Identifiant du tenant.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: '#tenant',
      Type: 'LONG',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'OTHER',
      ApiPath: '#tenant',
      DataType: 'LONG',
    },
    {
      id: null,
      Path: '_uds',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: '_uds',
      ShortName: '_uds',
      Description: null,
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: '#uds',
      Type: 'OBJECT',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'OTHER',
      ApiPath: '#uds',
      DataType: 'OBJECT',
    },
    {
      id: null,
      Path: '_unitType',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: '_unitType',
      ShortName: "Type d'unité archivistique",
      Description:
        'Mapping : unit-es-mapping.json. Type d’unité archivistique concerné : SIP, plan de classement, arbre de positionnement.',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: '#unitType',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'OTHER',
      ApiPath: '#unitType',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_up',
      StringSize: 'MEDIUM',
      Cardinality: 'MANY',
      FieldName: '_up',
      ShortName: 'Identifiant(s) des unités archivistiques parentes (parents immédiats)',
      Description:
        "Mapping : unit-es-mapping.json. Pour une unité archivistique, identifiant(s) des unités archivistiques parentes (parents immédiats). Pour un groupe d'objets, identifiant(s) des unités archivistiques représentées par ce groupe d’objets.",
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: '#unitups',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'OTHER',
      ApiPath: '#unitups',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_us',
      StringSize: 'MEDIUM',
      Cardinality: 'MANY',
      FieldName: '_us',
      ShortName: 'Identifiant(s) des unités archivistiques parentes',
      Description:
        'Mapping : unit-es-mapping.json. Tableau contenant la parentalité, c’est à dire l’ensemble des unités archivistiques parentes, indexé de la manière suivante : [ GUID1, GUID2, … ].',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: '#allunitups',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'OTHER',
      ApiPath: '#allunitups',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_validComputedInheritedRules',
      StringSize: null,
      Cardinality: 'ONE',
      FieldName: '_validComputedInheritedRules',
      ShortName: 'validComputedInheritedRules',
      Description: 'Indique si les règles calculées sont valides',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: '#validComputedInheritedRules',
      Type: 'BOOLEAN',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'MANAGEMENT',
      ApiPath: '#validComputedInheritedRules',
      DataType: 'BOOLEAN',
    },
    {
      id: null,
      Path: '_batchId',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: '_batchId',
      ShortName: 'Collect batch identifier',
      Description: 'Mapping : unit-es-mapping.json (collect-only)',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: '#batchId',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'OTHER',
      ApiPath: '#batchId',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: '_uploadPath',
      StringSize: 'MEDIUM',
      Cardinality: 'ONE',
      FieldName: '_uploadPath',
      ShortName: 'Collect initial upload path',
      Description: 'Mapping : unit-es-mapping.json (collect-only)',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: '#uploadPath',
      Type: 'KEYWORD',
      Origin: 'INTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'OTHER',
      ApiPath: '#uploadPath',
      DataType: 'STRING',
    },
    {
      id: null,
      Path: 'MyBoolean',
      StringSize: null,
      Cardinality: 'MANY',
      FieldName: 'MyBoolean',
      ShortName: 'MyBoolean',
      Description: 'Extension au SEDA. Elément de type booléen',
      CreationDate: null,
      LastUpdate: null,
      SedaField: null,
      ApiField: null,
      Type: 'BOOLEAN',
      Origin: 'EXTERNAL',
      Collection: Collection.ARCHIVE_UNIT,
      SedaVersions: null,
      Category: 'DESCRIPTION',
      ApiPath: 'MyBoolean',
      DataType: 'BOOLEAN',
    },
  ];

  getSchema(_collection: Collection): Observable<Schema> {
    return of(this.schema);
  }

  getSchemas(_collections: Collection[]): Observable<Schema[]> {
    return of([this.schema]);
  }

  public getDescriptiveSchemaTree(): Observable<ItemNode<SchemaElement>[]> {
    const recursiveSort = (node: ItemNode<SchemaElement>) => {
      node.children.sort((n1, n2) =>
        n1.children.length && !n2.children.length
          ? 1
          : !n1.children.length && n2.children.length
            ? -1
            : n1.item.ShortName.localeCompare(n2.item.ShortName),
      );
      node.children.forEach((n) => recursiveSort(n));
    };

    const removeLeavesWithTypeObject = (node: ItemNode<SchemaElement>) => {
      node.children = node.children.filter((child) => !(child.item.Type === 'OBJECT' && !child.children.length));
      node.children.forEach((child) => removeLeavesWithTypeObject(child));
    };

    return this.getSchema(Collection.ARCHIVE_UNIT).pipe(
      map((schema) => {
        const rootNode = schema
          .filter((e) => e.Category === 'DESCRIPTION' || e.Origin === 'EXTERNAL')
          .reduce(
            (acc, element) => {
              const path = element.Path.split('.').slice(0, -1);
              const parentNode = path.reduce((currentItem, p) => currentItem.children.find((n) => n.item.FieldName === p), acc) || acc;
              parentNode.children.push({
                item: element,
                children: [],
              });
              return acc;
            },
            { children: [] } as ItemNode<SchemaElement>,
          );

        removeLeavesWithTypeObject(rootNode);

        recursiveSort(rootNode);
        return rootNode.children;
      }),
    );
  }

  public getArchiveUnitProfileSchema(archiveUnitProfileId: string): Observable<Schema> {
    if (!archiveUnitProfileId) return of([]);

    let archiveUnitProfileSchema: Schema = JSON.parse(JSON.stringify(this.schema));

    archiveUnitProfileSchema = this.requiredConstraints(archiveUnitProfileSchema);
    archiveUnitProfileSchema = this.monoValuedConstraints(archiveUnitProfileSchema);
    archiveUnitProfileSchema = this.enumsConstraints(archiveUnitProfileSchema);
    archiveUnitProfileSchema = this.regexConstraints(archiveUnitProfileSchema);
    archiveUnitProfileSchema = this.cardinalityZeroConstrains(archiveUnitProfileSchema);

    return of(archiveUnitProfileSchema);
  }

  private applyConstraints = (schema: Schema, path: string, control: Control, cardinality?: EffectiveCardinality) => {
    const index = schema.findIndex((e) => e.Path === path);

    if (index < 0) return schema;

    const element = schema[index];
    const next: ProfiledSchemaElement = {
      ...element,
      Control: control,
      EffectiveCardinality: cardinality || element.Cardinality,
    };

    return [...schema.slice(0, index), next, ...schema.slice(index + 1)];
  };

  // C1 - https://assistance.programmevitam.fr/plugins/tracker/?aid=13004
  private requiredConstraints = (schema: Schema): Schema => {
    schema = this.applyConstraints(schema, 'Addressee', null, 'ONE_REQUIRED');
    schema = this.applyConstraints(schema, 'Addressee.BirthPlace', null, 'ONE_REQUIRED');
    schema = this.applyConstraints(schema, 'Addressee.FirstName', null, 'ONE_REQUIRED');

    schema = this.applyConstraints(schema, 'Agent', null, 'MANY_REQUIRED');
    return schema;
  };

  // C2 - https://assistance.programmevitam.fr/plugins/tracker/?aid=13004
  private monoValuedConstraints(schema: Schema): Schema {
    schema = this.applyConstraints(schema, 'Description', null, 'ONE_REQUIRED');
    schema = this.applyConstraints(schema, 'Writer', null, 'ONE');
    schema = this.applyConstraints(schema, 'Writer.Identifier', null, 'ONE');

    return schema;
  }

  // C3 - https://assistance.programmevitam.fr/plugins/tracker/?aid=13004
  private enumsConstraints(schema: Schema): Schema {
    schema = this.applyConstraints(schema, 'DescriptionLevel', {
      Type: 'SELECT',
      Values: ['Fonds', 'Subfonds', 'Class', 'Collection', 'Series', 'Subseries', 'RecordGrp', 'SubGrp', 'File', 'Item'],
    });

    schema = this.applyConstraints(
      schema,
      'Tag',
      {
        Type: 'SELECT',
        Values: ['Titi', 'Toto'],
        Comment: 'Titi ou Toto',
      },
      'ONE_REQUIRED',
    );

    schema = this.applyConstraints(schema, 'SigningInformation.SigningRole', {
      Type: 'SELECT',
      Values: ['SignedDocument', 'Timestamp', 'Signature', 'AdditionalProof'],
    });

    return schema;
  }

  // C4 - https://assistance.programmevitam.fr/plugins/tracker/?aid=13004
  private regexConstraints(schema: Schema): Schema {
    schema = this.applyConstraints(schema, 'Title', {
      Type: 'REGEX',
      Value: '^Fichier.*',
      Comment: "Doit commencer par 'Fichier'",
    });
    schema = this.applyConstraints(schema, 'Writer.Function', {
      Type: 'REGEX',
      Value: '^FN_.*',
      Comment: "Doit commencer par 'FN_'",
    });

    return schema;
  }

  // C7 - https://assistance.programmevitam.fr/plugins/tracker/?aid=13004
  private cardinalityZeroConstrains(schema: Schema): Schema {
    schema = this.applyConstraints(schema, 'Sender', null, 'ZERO');
    schema = this.applyConstraints(schema, 'Writer.BirthPlace', null, 'ZERO');
    schema = this.applyConstraints(schema, 'Writer.Nationality', null, 'ZERO');
    schema = this.applyConstraints(schema, 'Writer.FirstName', null, 'ZERO');
    schema = this.applyConstraints(schema, 'Writer.BirthName', null, 'ZERO');

    return schema;
  }
}
